"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3882],{

/***/ 79800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ livescoreClient; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var src_class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs
var src_inherits = __webpack_require__(28668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var src_create_super = __webpack_require__(26626);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var lib_axios = __webpack_require__(87066);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_wrap_native_super.mjs + 2 modules
var _wrap_native_super = __webpack_require__(25892);
;// CONCATENATED MODULE: ./src/api/livescore/generated/base.ts
/* tslint:disable */ /* eslint-disable */ /**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 




var base_BASE_PATH = "http://localhost:3001".replace(/\/+$/, "");
/**
 *
 * @export
 */ var COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "	",
    pipes: "|"
};
/**
 *
 * @export
 * @class BaseAPI
 */ var base_BaseAPI = function BaseAPI(configuration) {
    "use strict";
    var basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : base_BASE_PATH, axios = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : lib_axios/* default */.Z;
    (0,src_class_call_check/* default */.Z)(this, BaseAPI);
    this.basePath = basePath;
    this.axios = axios;
    if (configuration) {
        this.configuration = configuration;
        var _basePath;
        this.basePath = (_basePath = configuration.basePath) !== null && _basePath !== void 0 ? _basePath : basePath;
    }
};
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */ var RequiredError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0,src_inherits/* default */.Z)(RequiredError, Error1);
    var _super = (0,src_create_super/* default */.Z)(RequiredError);
    function RequiredError(field, msg) {
        (0,src_class_call_check/* default */.Z)(this, RequiredError);
        var _this;
        _this = _super.call(this, msg);
        _this.field = field;
        _this.name = "RequiredError";
        return _this;
    }
    return RequiredError;
}((0,_wrap_native_super/* default */.Z)(Error));
/**
 *
 * @export
 */ var base_operationServerMap = {};

;// CONCATENATED MODULE: ./src/api/livescore/generated/common.ts
/* tslint:disable */ /* eslint-disable */ /**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 




/**
 *
 * @export
 */ var common_DUMMY_BASE_URL = "https://example.com";
/**
 *
 * @throws {RequiredError}
 * @export
 */ var common_assertParamExists = function assertParamExists(functionName, paramName, paramValue) {
    if (paramValue === null || paramValue === undefined) {
        throw new RequiredError(paramName, "Required parameter ".concat(paramName, " was null or undefined when calling ").concat(functionName, "."));
    }
};
/**
 *
 * @export
 */ var setApiKeyToObject = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(object, keyParamName, configuration) {
        var localVarApiKeyValue, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(configuration && configuration.apiKey)) return [
                        3,
                        5
                    ];
                    if (!(typeof configuration.apiKey === "function")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        configuration.apiKey(keyParamName)
                    ];
                case 1:
                    _tmp = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        configuration.apiKey
                    ];
                case 3:
                    _tmp = _state.sent();
                    _state.label = 4;
                case 4:
                    localVarApiKeyValue = _tmp;
                    object[keyParamName] = localVarApiKeyValue;
                    _state.label = 5;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function setApiKeyToObject(object, keyParamName, configuration) {
        return _ref.apply(this, arguments);
    };
}();
/**
 *
 * @export
 */ var setBasicAuthToObject = function setBasicAuthToObject(object, configuration) {
    if (configuration && (configuration.username || configuration.password)) {
        object["auth"] = {
            username: configuration.username,
            password: configuration.password
        };
    }
};
/**
 *
 * @export
 */ var setBearerAuthToObject = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(object, configuration) {
        var accessToken, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(configuration && configuration.accessToken)) return [
                        3,
                        5
                    ];
                    if (!(typeof configuration.accessToken === "function")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        configuration.accessToken()
                    ];
                case 1:
                    _tmp = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        configuration.accessToken
                    ];
                case 3:
                    _tmp = _state.sent();
                    _state.label = 4;
                case 4:
                    accessToken = _tmp;
                    object["Authorization"] = "Bearer " + accessToken;
                    _state.label = 5;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function setBearerAuthToObject(object, configuration) {
        return _ref.apply(this, arguments);
    };
}();
/**
 *
 * @export
 */ var setOAuthToObject = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(object, name, scopes, configuration) {
        var localVarAccessTokenValue, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(configuration && configuration.accessToken)) return [
                        3,
                        5
                    ];
                    if (!(typeof configuration.accessToken === "function")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        configuration.accessToken(name, scopes)
                    ];
                case 1:
                    _tmp = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        configuration.accessToken
                    ];
                case 3:
                    _tmp = _state.sent();
                    _state.label = 4;
                case 4:
                    localVarAccessTokenValue = _tmp;
                    object["Authorization"] = "Bearer " + localVarAccessTokenValue;
                    _state.label = 5;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function setOAuthToObject(object, name, scopes, configuration) {
        return _ref.apply(this, arguments);
    };
}();
function setFlattenedQueryParams(urlSearchParams, parameter) {
    var key = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    if (parameter == null) return;
    if (typeof parameter === "object") {
        if (Array.isArray(parameter)) {
            parameter.forEach(function(item) {
                return setFlattenedQueryParams(urlSearchParams, item, key);
            });
        } else {
            Object.keys(parameter).forEach(function(currentKey) {
                return setFlattenedQueryParams(urlSearchParams, parameter[currentKey], "".concat(key).concat(key !== "" ? "." : "").concat(currentKey));
            });
        }
    } else {
        if (urlSearchParams.has(key)) {
            urlSearchParams.append(key, parameter);
        } else {
            urlSearchParams.set(key, parameter);
        }
    }
}
/**
 *
 * @export
 */ var common_setSearchParams = function setSearchParams(url) {
    for(var _len = arguments.length, objects = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        objects[_key - 1] = arguments[_key];
    }
    var searchParams = new URLSearchParams(url.search);
    setFlattenedQueryParams(searchParams, objects);
    url.search = searchParams.toString();
};
/**
 *
 * @export
 */ var serializeDataIfNeeded = function serializeDataIfNeeded(value, requestOptions, configuration) {
    var nonString = typeof value !== "string";
    var needsSerialization = nonString && configuration && configuration.isJsonMime ? configuration.isJsonMime(requestOptions.headers["Content-Type"]) : nonString;
    return needsSerialization ? JSON.stringify(value !== undefined ? value : {}) : value || "";
};
/**
 *
 * @export
 */ var common_toPathString = function toPathString(url) {
    return url.pathname + url.search + url.hash;
};
/**
 *
 * @export
 */ var common_createRequestFunction = function createRequestFunction(axiosArgs, globalAxios, BASE_PATH, configuration) {
    return function() {
        var axios = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : globalAxios, basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : BASE_PATH;
        var ref;
        var axiosRequestArgs = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, axiosArgs.options), {
            url: (axios.defaults.baseURL ? "" : (ref = configuration === null || configuration === void 0 ? void 0 : configuration.basePath) !== null && ref !== void 0 ? ref : basePath) + axiosArgs.url
        });
        return axios.request(axiosRequestArgs);
    };
};

;// CONCATENATED MODULE: ./src/api/livescore/generated/api/api-api.ts
/* tslint:disable */ /* eslint-disable */ /**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 






// Some imports not used depending on template conditions
// @ts-ignore

// @ts-ignore

/**
 * ApiApi - axios parameter creator
 * @export
 */ var ApiApiAxiosParamCreator = function ApiApiAxiosParamCreator(configuration) {
    return {
        /**
         * Get all competitions from Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiCompetitionsAllGet: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
            var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                localVarPath = "/api/competitions/all";
                localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                if (configuration) {
                    baseOptions = configuration.baseOptions;
                }
                localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                    method: "GET"
                }, baseOptions, options);
                localVarHeaderParameter = {};
                localVarQueryParameter = {};
                common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                return [
                    2,
                    {
                        url: common_toPathString(localVarUrlObj),
                        options: localVarRequestOptions
                    }
                ];
            });
        }),
        /**
         * Get configured countries for the AllCompetitions display
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiCompetitionsCountriesConfigGet: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
            var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                localVarPath = "/api/competitions/countries-config";
                localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                if (configuration) {
                    baseOptions = configuration.baseOptions;
                }
                localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                    method: "GET"
                }, baseOptions, options);
                localVarHeaderParameter = {};
                localVarQueryParameter = {};
                common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                return [
                    2,
                    {
                        url: common_toPathString(localVarUrlObj),
                        options: localVarRequestOptions
                    }
                ];
            });
        }),
        /**
         * Get enabled competitions from configured leagues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiCompetitionsEnabledGet: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
            var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                localVarPath = "/api/competitions/enabled";
                localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                if (configuration) {
                    baseOptions = configuration.baseOptions;
                }
                localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                    method: "GET"
                }, baseOptions, options);
                localVarHeaderParameter = {};
                localVarQueryParameter = {};
                common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                return [
                    2,
                    {
                        url: common_toPathString(localVarUrlObj),
                        options: localVarRequestOptions
                    }
                ];
            });
        }),
        /**
         * Get enabled and all competitions from configured leagues and Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiCompetitionsGet: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
            var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                localVarPath = "/api/competitions";
                localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                if (configuration) {
                    baseOptions = configuration.baseOptions;
                }
                localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                    method: "GET"
                }, baseOptions, options);
                localVarHeaderParameter = {};
                localVarQueryParameter = {};
                common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                return [
                    2,
                    {
                        url: common_toPathString(localVarUrlObj),
                        options: localVarRequestOptions
                    }
                ];
            });
        }),
        /**
         * Get competitor by id from Sportradar API
         * @param {string} competitorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiCompetitorCompetitorIdGet: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(competitorId) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'competitorId' is not null or undefined
                    common_assertParamExists("apiCompetitorCompetitorIdGet", "competitorId", competitorId);
                    localVarPath = "/api/competitor/{competitor_id}".replace("{competitor_id}", encodeURIComponent(String(competitorId)));
                    localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: common_toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(competitorId) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get favorites matches by ids
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiFavoritesGet: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(ids) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'ids' is not null or undefined
                    common_assertParamExists("apiFavoritesGet", "ids", ids);
                    localVarPath = "/api/favorites";
                    localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (ids !== undefined) {
                        localVarQueryParameter["ids"] = ids;
                    }
                    common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: common_toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(ids) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get favorites matches by ids
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiFavoritesIdsGet: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(ids) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'ids' is not null or undefined
                    common_assertParamExists("apiFavoritesIdsGet", "ids", ids);
                    localVarPath = "/api/favorites/{ids}".replace("{ids}", encodeURIComponent(String(ids)));
                    localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: common_toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(ids) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get formations by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiFormationsEventIdGet: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(eventId) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'eventId' is not null or undefined
                    common_assertParamExists("apiFormationsEventIdGet", "eventId", eventId);
                    localVarPath = "/api/formations/{event_id}".replace("{event_id}", encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: common_toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(eventId) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get h2h by id from Sportradar API
         * @param {string} homeId 
         * @param {string} awayId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiH2hGet: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(homeId, awayId) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    options = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                    // verify required parameter 'homeId' is not null or undefined
                    common_assertParamExists("apiH2hGet", "homeId", homeId);
                    // verify required parameter 'awayId' is not null or undefined
                    common_assertParamExists("apiH2hGet", "awayId", awayId);
                    localVarPath = "/api/h2h/";
                    localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (homeId !== undefined) {
                        localVarQueryParameter["home_id"] = homeId;
                    }
                    if (awayId !== undefined) {
                        localVarQueryParameter["away_id"] = awayId;
                    }
                    common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: common_toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(homeId, awayId) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get league by ids separated by \",\" from Sportradar API
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLeagueIdsIdsGet: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(ids) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'ids' is not null or undefined
                    common_assertParamExists("apiLeagueIdsIdsGet", "ids", ids);
                    localVarPath = "/api/league/ids/{ids}".replace("{ids}", encodeURIComponent(String(ids)));
                    localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: common_toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(ids) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get league by id from Sportradar API
         * @param {string} leagueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLeagueLeagueIdGet: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(leagueId) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'leagueId' is not null or undefined
                    common_assertParamExists("apiLeagueLeagueIdGet", "leagueId", leagueId);
                    localVarPath = "/api/league/{league_id}".replace("{league_id}", encodeURIComponent(String(leagueId)));
                    localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: common_toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(leagueId) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get season events by id from Sportradar API
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLeagueSeasonSeasonIdEventsGet: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(seasonId) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'seasonId' is not null or undefined
                    common_assertParamExists("apiLeagueSeasonSeasonIdEventsGet", "seasonId", seasonId);
                    localVarPath = "/api/league/season/{season_id}/events".replace("{season_id}", encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: common_toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(seasonId) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get matches for the provided date
         * @param {string} date Date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLivescoreDateGet: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(date) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'date' is not null or undefined
                    common_assertParamExists("apiLivescoreDateGet", "date", date);
                    localVarPath = "/api/livescore/{date}".replace("{date}", encodeURIComponent(String(date)));
                    localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: common_toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(date) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get odds for the provided date
         * @param {string} date Date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLivescoreDateOddsGet: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(date) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'date' is not null or undefined
                    common_assertParamExists("apiLivescoreDateOddsGet", "date", date);
                    localVarPath = "/api/livescore/{date}/odds".replace("{date}", encodeURIComponent(String(date)));
                    localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: common_toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(date) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get live matches
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLivescoreLiveGet: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
            var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                localVarPath = "/api/livescore/live";
                localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                if (configuration) {
                    baseOptions = configuration.baseOptions;
                }
                localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                    method: "GET"
                }, baseOptions, options);
                localVarHeaderParameter = {};
                localVarQueryParameter = {};
                common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                return [
                    2,
                    {
                        url: common_toPathString(localVarUrlObj),
                        options: localVarRequestOptions
                    }
                ];
            });
        }),
        /**
         * Get match live timeline data by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiMatchEventIdAllLiveGet: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(eventId) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'eventId' is not null or undefined
                    common_assertParamExists("apiMatchEventIdAllLiveGet", "eventId", eventId);
                    localVarPath = "/api/match/{event_id}/all/live".replace("{event_id}", encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: common_toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(eventId) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get match by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiMatchEventIdGet: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(eventId) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'eventId' is not null or undefined
                    common_assertParamExists("apiMatchEventIdGet", "eventId", eventId);
                    localVarPath = "/api/match/{event_id}".replace("{event_id}", encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: common_toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(eventId) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get match live data by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiMatchEventIdLiveGet: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(eventId) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'eventId' is not null or undefined
                    common_assertParamExists("apiMatchEventIdLiveGet", "eventId", eventId);
                    localVarPath = "/api/match/{event_id}/live".replace("{event_id}", encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: common_toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(eventId) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get match preview by id from Sportradar API. It has steps: generating preview, fetching, error, success. It should be listen to the error, result and status event names.
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiMatchEventIdPreviewGet: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(eventId) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'eventId' is not null or undefined
                    common_assertParamExists("apiMatchEventIdPreviewGet", "eventId", eventId);
                    localVarPath = "/api/match/{event_id}/preview".replace("{event_id}", encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: common_toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(eventId) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get match timeline by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiMatchEventIdTimelineGet: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(eventId) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'eventId' is not null or undefined
                    common_assertParamExists("apiMatchEventIdTimelineGet", "eventId", eventId);
                    localVarPath = "/api/match/{event_id}/timeline".replace("{event_id}", encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: common_toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(eventId) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get match live timeline data by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiMatchEventIdTimelineLiveGet: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(eventId) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'eventId' is not null or undefined
                    common_assertParamExists("apiMatchEventIdTimelineLiveGet", "eventId", eventId);
                    localVarPath = "/api/match/{event_id}/timeline/live".replace("{event_id}", encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: common_toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(eventId) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get player by id from Sportradar API
         * @param {string} playerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiPlayerPlayerIdGet: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(playerId) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'playerId' is not null or undefined
                    common_assertParamExists("apiPlayerPlayerIdGet", "playerId", playerId);
                    localVarPath = "/api/player/{player_id}".replace("{player_id}", encodeURIComponent(String(playerId)));
                    localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: common_toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(playerId) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get player statistics by id from Sportradar API
         * @param {string} playerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiPlayerPlayerIdStatsGet: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(playerId) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'playerId' is not null or undefined
                    common_assertParamExists("apiPlayerPlayerIdStatsGet", "playerId", playerId);
                    localVarPath = "/api/player/{player_id}/stats".replace("{player_id}", encodeURIComponent(String(playerId)));
                    localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: common_toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(playerId) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get all players
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiPlayersGet: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
            var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                localVarPath = "/api/players";
                localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                if (configuration) {
                    baseOptions = configuration.baseOptions;
                }
                localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                    method: "GET"
                }, baseOptions, options);
                localVarHeaderParameter = {};
                localVarQueryParameter = {};
                common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                return [
                    2,
                    {
                        url: common_toPathString(localVarUrlObj),
                        options: localVarRequestOptions
                    }
                ];
            });
        }),
        /**
         * Get favorites players by ids
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiPlayersIdsGet: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(ids) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'ids' is not null or undefined
                    common_assertParamExists("apiPlayersIdsGet", "ids", ids);
                    localVarPath = "/api/players/{ids}".replace("{ids}", encodeURIComponent(String(ids)));
                    localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: common_toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(ids) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Search for players, teams, competitions
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiSearchGet: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(q) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'q' is not null or undefined
                    common_assertParamExists("apiSearchGet", "q", q);
                    localVarPath = "/api/search";
                    localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (q !== undefined) {
                        localVarQueryParameter["q"] = q;
                    }
                    common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: common_toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(q) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Search for leagues
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiSearchLeaguesGet: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(q) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'q' is not null or undefined
                    common_assertParamExists("apiSearchLeaguesGet", "q", q);
                    localVarPath = "/api/search/leagues";
                    localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (q !== undefined) {
                        localVarQueryParameter["q"] = q;
                    }
                    common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: common_toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(q) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Search for players
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiSearchPlayersGet: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(q) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'q' is not null or undefined
                    common_assertParamExists("apiSearchPlayersGet", "q", q);
                    localVarPath = "/api/search/players";
                    localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (q !== undefined) {
                        localVarQueryParameter["q"] = q;
                    }
                    common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: common_toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(q) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get league table by id from Sportradar API
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiSeasonTableSeasonIdGet: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(seasonId) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'seasonId' is not null or undefined
                    common_assertParamExists("apiSeasonTableSeasonIdGet", "seasonId", seasonId);
                    localVarPath = "/api/season-table/{season_id}".replace("{season_id}", encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: common_toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(seasonId) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get all teams from Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiTeamsGet: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
            var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                localVarPath = "/api/teams";
                localVarUrlObj = new URL(localVarPath, common_DUMMY_BASE_URL);
                if (configuration) {
                    baseOptions = configuration.baseOptions;
                }
                localVarRequestOptions = (0,src_object_spread/* default */.Z)({
                    method: "GET"
                }, baseOptions, options);
                localVarHeaderParameter = {};
                localVarQueryParameter = {};
                common_setSearchParams(localVarUrlObj, localVarQueryParameter);
                headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                localVarRequestOptions.headers = (0,src_object_spread/* default */.Z)({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                return [
                    2,
                    {
                        url: common_toPathString(localVarUrlObj),
                        options: localVarRequestOptions
                    }
                ];
            });
        })
    };
};
/**
 * ApiApi - functional programming interface
 * @export
 */ var ApiApiFp = function ApiApiFp(configuration) {
    var localVarAxiosParamCreator = ApiApiAxiosParamCreator(configuration);
    return {
        apiCompetitionsAllGet: /**
         * Get all competitions from Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiCompetitionsAllGet(options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiCompetitionsAllGet(options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiCompetitionsAllGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiCompetitionsCountriesConfigGet: /**
         * Get configured countries for the AllCompetitions display
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiCompetitionsCountriesConfigGet(options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiCompetitionsCountriesConfigGet(options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiCompetitionsCountriesConfigGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiCompetitionsEnabledGet: /**
         * Get enabled competitions from configured leagues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiCompetitionsEnabledGet(options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiCompetitionsEnabledGet(options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiCompetitionsEnabledGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiCompetitionsGet: /**
         * Get enabled and all competitions from configured leagues and Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiCompetitionsGet(options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiCompetitionsGet(options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiCompetitionsGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiCompetitorCompetitorIdGet: /**
         * Get competitor by id from Sportradar API
         * @param {string} competitorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiCompetitorCompetitorIdGet(competitorId, options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiCompetitorCompetitorIdGet(competitorId, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiCompetitorCompetitorIdGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiFavoritesGet: /**
         * Get favorites matches by ids
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiFavoritesGet(ids, options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiFavoritesGet(ids, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiFavoritesGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiFavoritesIdsGet: /**
         * Get favorites matches by ids
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiFavoritesIdsGet(ids, options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiFavoritesIdsGet(ids, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiFavoritesIdsGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiFormationsEventIdGet: /**
         * Get formations by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiFormationsEventIdGet(eventId, options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiFormationsEventIdGet(eventId, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiFormationsEventIdGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiH2hGet: /**
         * Get h2h by id from Sportradar API
         * @param {string} homeId 
         * @param {string} awayId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiH2hGet(homeId, awayId, options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiH2hGet(homeId, awayId, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiH2hGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiLeagueIdsIdsGet: /**
         * Get league by ids separated by \",\" from Sportradar API
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiLeagueIdsIdsGet(ids, options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiLeagueIdsIdsGet(ids, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiLeagueIdsIdsGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiLeagueLeagueIdGet: /**
         * Get league by id from Sportradar API
         * @param {string} leagueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiLeagueLeagueIdGet(leagueId, options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiLeagueLeagueIdGet(leagueId, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiLeagueLeagueIdGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiLeagueSeasonSeasonIdEventsGet: /**
         * Get season events by id from Sportradar API
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiLeagueSeasonSeasonIdEventsGet(seasonId, options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiLeagueSeasonSeasonIdEventsGet(seasonId, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiLeagueSeasonSeasonIdEventsGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiLivescoreDateGet: /**
         * Get matches for the provided date
         * @param {string} date Date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiLivescoreDateGet(date, options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiLivescoreDateGet(date, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiLivescoreDateGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiLivescoreDateOddsGet: /**
         * Get odds for the provided date
         * @param {string} date Date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiLivescoreDateOddsGet(date, options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiLivescoreDateOddsGet(date, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiLivescoreDateOddsGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiLivescoreLiveGet: /**
         * Get live matches
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiLivescoreLiveGet(options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiLivescoreLiveGet(options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiLivescoreLiveGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiMatchEventIdAllLiveGet: /**
         * Get match live timeline data by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiMatchEventIdAllLiveGet(eventId, options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiMatchEventIdAllLiveGet(eventId, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiMatchEventIdAllLiveGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiMatchEventIdGet: /**
         * Get match by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiMatchEventIdGet(eventId, options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiMatchEventIdGet(eventId, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiMatchEventIdGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiMatchEventIdLiveGet: /**
         * Get match live data by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiMatchEventIdLiveGet(eventId, options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiMatchEventIdLiveGet(eventId, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiMatchEventIdLiveGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiMatchEventIdPreviewGet: /**
         * Get match preview by id from Sportradar API. It has steps: generating preview, fetching, error, success. It should be listen to the error, result and status event names.
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiMatchEventIdPreviewGet(eventId, options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiMatchEventIdPreviewGet(eventId, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiMatchEventIdPreviewGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiMatchEventIdTimelineGet: /**
         * Get match timeline by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiMatchEventIdTimelineGet(eventId, options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiMatchEventIdTimelineGet(eventId, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiMatchEventIdTimelineGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiMatchEventIdTimelineLiveGet: /**
         * Get match live timeline data by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiMatchEventIdTimelineLiveGet(eventId, options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiMatchEventIdTimelineLiveGet(eventId, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiMatchEventIdTimelineLiveGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiPlayerPlayerIdGet: /**
         * Get player by id from Sportradar API
         * @param {string} playerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiPlayerPlayerIdGet(playerId, options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiPlayerPlayerIdGet(playerId, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiPlayerPlayerIdGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiPlayerPlayerIdStatsGet: /**
         * Get player statistics by id from Sportradar API
         * @param {string} playerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiPlayerPlayerIdStatsGet(playerId, options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiPlayerPlayerIdStatsGet(playerId, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiPlayerPlayerIdStatsGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiPlayersGet: /**
         * Get all players
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiPlayersGet(options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiPlayersGet(options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiPlayersGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiPlayersIdsGet: /**
         * Get favorites players by ids
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiPlayersIdsGet(ids, options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiPlayersIdsGet(ids, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiPlayersIdsGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiSearchGet: /**
         * Search for players, teams, competitions
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiSearchGet(q, options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiSearchGet(q, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiSearchGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiSearchLeaguesGet: /**
         * Search for leagues
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiSearchLeaguesGet(q, options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiSearchLeaguesGet(q, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiSearchLeaguesGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiSearchPlayersGet: /**
         * Search for players
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiSearchPlayersGet(q, options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiSearchPlayersGet(q, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiSearchPlayersGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiSeasonTableSeasonIdGet: /**
         * Get league table by id from Sportradar API
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiSeasonTableSeasonIdGet(seasonId, options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiSeasonTableSeasonIdGet(seasonId, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiSeasonTableSeasonIdGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiTeamsGet: /**
         * Get all teams from Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiTeamsGet(options) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiTeamsGet(options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = base_operationServerMap["ApiApi.apiTeamsGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return common_createRequestFunction(localVarAxiosArgs, lib_axios/* default */.Z, base_BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * ApiApi - factory interface
 * @export
 */ var ApiApiFactory = function ApiApiFactory(configuration, basePath, axios) {
    var localVarFp = ApiApiFp(configuration);
    return {
        /**
         * Get all competitions from Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiCompetitionsAllGet: function apiCompetitionsAllGet(options) {
            return localVarFp.apiCompetitionsAllGet(options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get configured countries for the AllCompetitions display
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiCompetitionsCountriesConfigGet: function apiCompetitionsCountriesConfigGet(options) {
            return localVarFp.apiCompetitionsCountriesConfigGet(options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get enabled competitions from configured leagues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiCompetitionsEnabledGet: function apiCompetitionsEnabledGet(options) {
            return localVarFp.apiCompetitionsEnabledGet(options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get enabled and all competitions from configured leagues and Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiCompetitionsGet: function apiCompetitionsGet(options) {
            return localVarFp.apiCompetitionsGet(options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get competitor by id from Sportradar API
         * @param {ApiApiApiCompetitorCompetitorIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiCompetitorCompetitorIdGet: function apiCompetitorCompetitorIdGet(requestParameters, options) {
            return localVarFp.apiCompetitorCompetitorIdGet(requestParameters.competitorId, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get favorites matches by ids
         * @param {ApiApiApiFavoritesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiFavoritesGet: function apiFavoritesGet(requestParameters, options) {
            return localVarFp.apiFavoritesGet(requestParameters.ids, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get favorites matches by ids
         * @param {ApiApiApiFavoritesIdsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiFavoritesIdsGet: function apiFavoritesIdsGet(requestParameters, options) {
            return localVarFp.apiFavoritesIdsGet(requestParameters.ids, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get formations by id from Sportradar API
         * @param {ApiApiApiFormationsEventIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiFormationsEventIdGet: function apiFormationsEventIdGet(requestParameters, options) {
            return localVarFp.apiFormationsEventIdGet(requestParameters.eventId, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get h2h by id from Sportradar API
         * @param {ApiApiApiH2hGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiH2hGet: function apiH2hGet(requestParameters, options) {
            return localVarFp.apiH2hGet(requestParameters.homeId, requestParameters.awayId, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get league by ids separated by \",\" from Sportradar API
         * @param {ApiApiApiLeagueIdsIdsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLeagueIdsIdsGet: function apiLeagueIdsIdsGet(requestParameters, options) {
            return localVarFp.apiLeagueIdsIdsGet(requestParameters.ids, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get league by id from Sportradar API
         * @param {ApiApiApiLeagueLeagueIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLeagueLeagueIdGet: function apiLeagueLeagueIdGet(requestParameters, options) {
            return localVarFp.apiLeagueLeagueIdGet(requestParameters.leagueId, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get season events by id from Sportradar API
         * @param {ApiApiApiLeagueSeasonSeasonIdEventsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLeagueSeasonSeasonIdEventsGet: function apiLeagueSeasonSeasonIdEventsGet(requestParameters, options) {
            return localVarFp.apiLeagueSeasonSeasonIdEventsGet(requestParameters.seasonId, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get matches for the provided date
         * @param {ApiApiApiLivescoreDateGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLivescoreDateGet: function apiLivescoreDateGet(requestParameters, options) {
            return localVarFp.apiLivescoreDateGet(requestParameters.date, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get odds for the provided date
         * @param {ApiApiApiLivescoreDateOddsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLivescoreDateOddsGet: function apiLivescoreDateOddsGet(requestParameters, options) {
            return localVarFp.apiLivescoreDateOddsGet(requestParameters.date, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get live matches
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLivescoreLiveGet: function apiLivescoreLiveGet(options) {
            return localVarFp.apiLivescoreLiveGet(options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get match live timeline data by id from Sportradar API
         * @param {ApiApiApiMatchEventIdAllLiveGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiMatchEventIdAllLiveGet: function apiMatchEventIdAllLiveGet(requestParameters, options) {
            return localVarFp.apiMatchEventIdAllLiveGet(requestParameters.eventId, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get match by id from Sportradar API
         * @param {ApiApiApiMatchEventIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiMatchEventIdGet: function apiMatchEventIdGet(requestParameters, options) {
            return localVarFp.apiMatchEventIdGet(requestParameters.eventId, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get match live data by id from Sportradar API
         * @param {ApiApiApiMatchEventIdLiveGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiMatchEventIdLiveGet: function apiMatchEventIdLiveGet(requestParameters, options) {
            return localVarFp.apiMatchEventIdLiveGet(requestParameters.eventId, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get match preview by id from Sportradar API. It has steps: generating preview, fetching, error, success. It should be listen to the error, result and status event names.
         * @param {ApiApiApiMatchEventIdPreviewGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiMatchEventIdPreviewGet: function apiMatchEventIdPreviewGet(requestParameters, options) {
            return localVarFp.apiMatchEventIdPreviewGet(requestParameters.eventId, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get match timeline by id from Sportradar API
         * @param {ApiApiApiMatchEventIdTimelineGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiMatchEventIdTimelineGet: function apiMatchEventIdTimelineGet(requestParameters, options) {
            return localVarFp.apiMatchEventIdTimelineGet(requestParameters.eventId, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get match live timeline data by id from Sportradar API
         * @param {ApiApiApiMatchEventIdTimelineLiveGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiMatchEventIdTimelineLiveGet: function apiMatchEventIdTimelineLiveGet(requestParameters, options) {
            return localVarFp.apiMatchEventIdTimelineLiveGet(requestParameters.eventId, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get player by id from Sportradar API
         * @param {ApiApiApiPlayerPlayerIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiPlayerPlayerIdGet: function apiPlayerPlayerIdGet(requestParameters, options) {
            return localVarFp.apiPlayerPlayerIdGet(requestParameters.playerId, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get player statistics by id from Sportradar API
         * @param {ApiApiApiPlayerPlayerIdStatsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiPlayerPlayerIdStatsGet: function apiPlayerPlayerIdStatsGet(requestParameters, options) {
            return localVarFp.apiPlayerPlayerIdStatsGet(requestParameters.playerId, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get all players
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiPlayersGet: function apiPlayersGet(options) {
            return localVarFp.apiPlayersGet(options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get favorites players by ids
         * @param {ApiApiApiPlayersIdsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiPlayersIdsGet: function apiPlayersIdsGet(requestParameters, options) {
            return localVarFp.apiPlayersIdsGet(requestParameters.ids, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Search for players, teams, competitions
         * @param {ApiApiApiSearchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiSearchGet: function apiSearchGet(requestParameters, options) {
            return localVarFp.apiSearchGet(requestParameters.q, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Search for leagues
         * @param {ApiApiApiSearchLeaguesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiSearchLeaguesGet: function apiSearchLeaguesGet(requestParameters, options) {
            return localVarFp.apiSearchLeaguesGet(requestParameters.q, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Search for players
         * @param {ApiApiApiSearchPlayersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiSearchPlayersGet: function apiSearchPlayersGet(requestParameters, options) {
            return localVarFp.apiSearchPlayersGet(requestParameters.q, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get league table by id from Sportradar API
         * @param {ApiApiApiSeasonTableSeasonIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiSeasonTableSeasonIdGet: function apiSeasonTableSeasonIdGet(requestParameters, options) {
            return localVarFp.apiSeasonTableSeasonIdGet(requestParameters.seasonId, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get all teams from Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiTeamsGet: function apiTeamsGet(options) {
            return localVarFp.apiTeamsGet(options).then(function(request) {
                return request(axios, basePath);
            });
        }
    };
};
/**
 * ApiApi - object-oriented interface
 * @export
 * @class ApiApi
 * @extends {BaseAPI}
 */ var ApiApi = /*#__PURE__*/ function(BaseAPI) {
    "use strict";
    (0,src_inherits/* default */.Z)(ApiApi, BaseAPI);
    var _super = (0,src_create_super/* default */.Z)(ApiApi);
    function ApiApi() {
        (0,src_class_call_check/* default */.Z)(this, ApiApi);
        return _super.apply(this, arguments);
    }
    var _proto = ApiApi.prototype;
    /**
     * Get all competitions from Sportradar API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiCompetitionsAllGet = function apiCompetitionsAllGet(options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiCompetitionsAllGet(options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get configured countries for the AllCompetitions display
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiCompetitionsCountriesConfigGet = function apiCompetitionsCountriesConfigGet(options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiCompetitionsCountriesConfigGet(options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get enabled competitions from configured leagues
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiCompetitionsEnabledGet = function apiCompetitionsEnabledGet(options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiCompetitionsEnabledGet(options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get enabled and all competitions from configured leagues and Sportradar API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiCompetitionsGet = function apiCompetitionsGet(options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiCompetitionsGet(options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get competitor by id from Sportradar API
     * @param {ApiApiApiCompetitorCompetitorIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiCompetitorCompetitorIdGet = function apiCompetitorCompetitorIdGet(requestParameters, options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiCompetitorCompetitorIdGet(requestParameters.competitorId, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get favorites matches by ids
     * @param {ApiApiApiFavoritesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiFavoritesGet = function apiFavoritesGet(requestParameters, options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiFavoritesGet(requestParameters.ids, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get favorites matches by ids
     * @param {ApiApiApiFavoritesIdsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiFavoritesIdsGet = function apiFavoritesIdsGet(requestParameters, options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiFavoritesIdsGet(requestParameters.ids, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get formations by id from Sportradar API
     * @param {ApiApiApiFormationsEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiFormationsEventIdGet = function apiFormationsEventIdGet(requestParameters, options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiFormationsEventIdGet(requestParameters.eventId, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get h2h by id from Sportradar API
     * @param {ApiApiApiH2hGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiH2hGet = function apiH2hGet(requestParameters, options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiH2hGet(requestParameters.homeId, requestParameters.awayId, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get league by ids separated by \",\" from Sportradar API
     * @param {ApiApiApiLeagueIdsIdsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiLeagueIdsIdsGet = function apiLeagueIdsIdsGet(requestParameters, options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiLeagueIdsIdsGet(requestParameters.ids, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get league by id from Sportradar API
     * @param {ApiApiApiLeagueLeagueIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiLeagueLeagueIdGet = function apiLeagueLeagueIdGet(requestParameters, options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiLeagueLeagueIdGet(requestParameters.leagueId, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get season events by id from Sportradar API
     * @param {ApiApiApiLeagueSeasonSeasonIdEventsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiLeagueSeasonSeasonIdEventsGet = function apiLeagueSeasonSeasonIdEventsGet(requestParameters, options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiLeagueSeasonSeasonIdEventsGet(requestParameters.seasonId, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get matches for the provided date
     * @param {ApiApiApiLivescoreDateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiLivescoreDateGet = function apiLivescoreDateGet(requestParameters, options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiLivescoreDateGet(requestParameters.date, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get odds for the provided date
     * @param {ApiApiApiLivescoreDateOddsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiLivescoreDateOddsGet = function apiLivescoreDateOddsGet(requestParameters, options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiLivescoreDateOddsGet(requestParameters.date, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get live matches
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiLivescoreLiveGet = function apiLivescoreLiveGet(options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiLivescoreLiveGet(options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get match live timeline data by id from Sportradar API
     * @param {ApiApiApiMatchEventIdAllLiveGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiMatchEventIdAllLiveGet = function apiMatchEventIdAllLiveGet(requestParameters, options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiMatchEventIdAllLiveGet(requestParameters.eventId, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get match by id from Sportradar API
     * @param {ApiApiApiMatchEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiMatchEventIdGet = function apiMatchEventIdGet(requestParameters, options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiMatchEventIdGet(requestParameters.eventId, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get match live data by id from Sportradar API
     * @param {ApiApiApiMatchEventIdLiveGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiMatchEventIdLiveGet = function apiMatchEventIdLiveGet(requestParameters, options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiMatchEventIdLiveGet(requestParameters.eventId, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get match preview by id from Sportradar API. It has steps: generating preview, fetching, error, success. It should be listen to the error, result and status event names.
     * @param {ApiApiApiMatchEventIdPreviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiMatchEventIdPreviewGet = function apiMatchEventIdPreviewGet(requestParameters, options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiMatchEventIdPreviewGet(requestParameters.eventId, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get match timeline by id from Sportradar API
     * @param {ApiApiApiMatchEventIdTimelineGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiMatchEventIdTimelineGet = function apiMatchEventIdTimelineGet(requestParameters, options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiMatchEventIdTimelineGet(requestParameters.eventId, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get match live timeline data by id from Sportradar API
     * @param {ApiApiApiMatchEventIdTimelineLiveGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiMatchEventIdTimelineLiveGet = function apiMatchEventIdTimelineLiveGet(requestParameters, options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiMatchEventIdTimelineLiveGet(requestParameters.eventId, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get player by id from Sportradar API
     * @param {ApiApiApiPlayerPlayerIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiPlayerPlayerIdGet = function apiPlayerPlayerIdGet(requestParameters, options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiPlayerPlayerIdGet(requestParameters.playerId, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get player statistics by id from Sportradar API
     * @param {ApiApiApiPlayerPlayerIdStatsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiPlayerPlayerIdStatsGet = function apiPlayerPlayerIdStatsGet(requestParameters, options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiPlayerPlayerIdStatsGet(requestParameters.playerId, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get all players
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiPlayersGet = function apiPlayersGet(options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiPlayersGet(options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get favorites players by ids
     * @param {ApiApiApiPlayersIdsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiPlayersIdsGet = function apiPlayersIdsGet(requestParameters, options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiPlayersIdsGet(requestParameters.ids, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Search for players, teams, competitions
     * @param {ApiApiApiSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiSearchGet = function apiSearchGet(requestParameters, options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiSearchGet(requestParameters.q, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Search for leagues
     * @param {ApiApiApiSearchLeaguesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiSearchLeaguesGet = function apiSearchLeaguesGet(requestParameters, options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiSearchLeaguesGet(requestParameters.q, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Search for players
     * @param {ApiApiApiSearchPlayersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiSearchPlayersGet = function apiSearchPlayersGet(requestParameters, options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiSearchPlayersGet(requestParameters.q, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get league table by id from Sportradar API
     * @param {ApiApiApiSeasonTableSeasonIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiSeasonTableSeasonIdGet = function apiSeasonTableSeasonIdGet(requestParameters, options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiSeasonTableSeasonIdGet(requestParameters.seasonId, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get all teams from Sportradar API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */ _proto.apiTeamsGet = function apiTeamsGet(options) {
        var _this = this;
        return ApiApiFp(this.configuration).apiTeamsGet(options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    return ApiApi;
}(base_BaseAPI);

;// CONCATENATED MODULE: ./src/api/livescore/generated/api/competitions-api.ts
/* tslint:disable */ /* eslint-disable */ /**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 






// Some imports not used depending on template conditions
// @ts-ignore

// @ts-ignore

/**
 * CompetitionsApi - axios parameter creator
 * @export
 */ var CompetitionsApiAxiosParamCreator = function CompetitionsApiAxiosParamCreator(configuration) {
    return {
        /**
         * Get all competitions from Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiCompetitionsAllGet: /*#__PURE__*/ _async_to_generator(function() {
            var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                localVarPath = "/api/competitions/all";
                localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                if (configuration) {
                    baseOptions = configuration.baseOptions;
                }
                localVarRequestOptions = _object_spread({
                    method: "GET"
                }, baseOptions, options);
                localVarHeaderParameter = {};
                localVarQueryParameter = {};
                setSearchParams(localVarUrlObj, localVarQueryParameter);
                headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                return [
                    2,
                    {
                        url: toPathString(localVarUrlObj),
                        options: localVarRequestOptions
                    }
                ];
            });
        }),
        /**
         * Get configured countries for the AllCompetitions display
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiCompetitionsCountriesConfigGet: /*#__PURE__*/ _async_to_generator(function() {
            var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                localVarPath = "/api/competitions/countries-config";
                localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                if (configuration) {
                    baseOptions = configuration.baseOptions;
                }
                localVarRequestOptions = _object_spread({
                    method: "GET"
                }, baseOptions, options);
                localVarHeaderParameter = {};
                localVarQueryParameter = {};
                setSearchParams(localVarUrlObj, localVarQueryParameter);
                headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                return [
                    2,
                    {
                        url: toPathString(localVarUrlObj),
                        options: localVarRequestOptions
                    }
                ];
            });
        }),
        /**
         * Get enabled competitions from configured leagues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiCompetitionsEnabledGet: /*#__PURE__*/ _async_to_generator(function() {
            var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                localVarPath = "/api/competitions/enabled";
                localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                if (configuration) {
                    baseOptions = configuration.baseOptions;
                }
                localVarRequestOptions = _object_spread({
                    method: "GET"
                }, baseOptions, options);
                localVarHeaderParameter = {};
                localVarQueryParameter = {};
                setSearchParams(localVarUrlObj, localVarQueryParameter);
                headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                return [
                    2,
                    {
                        url: toPathString(localVarUrlObj),
                        options: localVarRequestOptions
                    }
                ];
            });
        }),
        /**
         * Get enabled and all competitions from configured leagues and Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiCompetitionsGet: /*#__PURE__*/ _async_to_generator(function() {
            var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                localVarPath = "/api/competitions";
                localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                if (configuration) {
                    baseOptions = configuration.baseOptions;
                }
                localVarRequestOptions = _object_spread({
                    method: "GET"
                }, baseOptions, options);
                localVarHeaderParameter = {};
                localVarQueryParameter = {};
                setSearchParams(localVarUrlObj, localVarQueryParameter);
                headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                return [
                    2,
                    {
                        url: toPathString(localVarUrlObj),
                        options: localVarRequestOptions
                    }
                ];
            });
        })
    };
};
/**
 * CompetitionsApi - functional programming interface
 * @export
 */ var CompetitionsApiFp = function CompetitionsApiFp(configuration) {
    var localVarAxiosParamCreator = CompetitionsApiAxiosParamCreator(configuration);
    return {
        apiCompetitionsAllGet: /**
         * Get all competitions from Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiCompetitionsAllGet(options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiCompetitionsAllGet(options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["CompetitionsApi.apiCompetitionsAllGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiCompetitionsCountriesConfigGet: /**
         * Get configured countries for the AllCompetitions display
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiCompetitionsCountriesConfigGet(options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiCompetitionsCountriesConfigGet(options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["CompetitionsApi.apiCompetitionsCountriesConfigGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiCompetitionsEnabledGet: /**
         * Get enabled competitions from configured leagues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiCompetitionsEnabledGet(options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiCompetitionsEnabledGet(options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["CompetitionsApi.apiCompetitionsEnabledGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiCompetitionsGet: /**
         * Get enabled and all competitions from configured leagues and Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiCompetitionsGet(options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiCompetitionsGet(options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["CompetitionsApi.apiCompetitionsGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * CompetitionsApi - factory interface
 * @export
 */ var CompetitionsApiFactory = function CompetitionsApiFactory(configuration, basePath, axios) {
    var localVarFp = CompetitionsApiFp(configuration);
    return {
        /**
         * Get all competitions from Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiCompetitionsAllGet: function apiCompetitionsAllGet(options) {
            return localVarFp.apiCompetitionsAllGet(options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get configured countries for the AllCompetitions display
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiCompetitionsCountriesConfigGet: function apiCompetitionsCountriesConfigGet(options) {
            return localVarFp.apiCompetitionsCountriesConfigGet(options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get enabled competitions from configured leagues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiCompetitionsEnabledGet: function apiCompetitionsEnabledGet(options) {
            return localVarFp.apiCompetitionsEnabledGet(options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get enabled and all competitions from configured leagues and Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiCompetitionsGet: function apiCompetitionsGet(options) {
            return localVarFp.apiCompetitionsGet(options).then(function(request) {
                return request(axios, basePath);
            });
        }
    };
};
/**
 * CompetitionsApi - object-oriented interface
 * @export
 * @class CompetitionsApi
 * @extends {BaseAPI}
 */ var CompetitionsApi = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(BaseAPI) {
    "use strict";
    _inherits(CompetitionsApi, BaseAPI);
    var _super = _create_super(CompetitionsApi);
    function CompetitionsApi() {
        _class_call_check(this, CompetitionsApi);
        return _super.apply(this, arguments);
    }
    var _proto = CompetitionsApi.prototype;
    /**
     * Get all competitions from Sportradar API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompetitionsApi
     */ _proto.apiCompetitionsAllGet = function apiCompetitionsAllGet(options) {
        var _this = this;
        return CompetitionsApiFp(this.configuration).apiCompetitionsAllGet(options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get configured countries for the AllCompetitions display
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompetitionsApi
     */ _proto.apiCompetitionsCountriesConfigGet = function apiCompetitionsCountriesConfigGet(options) {
        var _this = this;
        return CompetitionsApiFp(this.configuration).apiCompetitionsCountriesConfigGet(options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get enabled competitions from configured leagues
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompetitionsApi
     */ _proto.apiCompetitionsEnabledGet = function apiCompetitionsEnabledGet(options) {
        var _this = this;
        return CompetitionsApiFp(this.configuration).apiCompetitionsEnabledGet(options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get enabled and all competitions from configured leagues and Sportradar API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompetitionsApi
     */ _proto.apiCompetitionsGet = function apiCompetitionsGet(options) {
        var _this = this;
        return CompetitionsApiFp(this.configuration).apiCompetitionsGet(options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    return CompetitionsApi;
}(BaseAPI)));

;// CONCATENATED MODULE: ./src/api/livescore/generated/api/competitor-api.ts
/* tslint:disable */ /* eslint-disable */ /**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 






// Some imports not used depending on template conditions
// @ts-ignore

// @ts-ignore

/**
 * CompetitorApi - axios parameter creator
 * @export
 */ var CompetitorApiAxiosParamCreator = function CompetitorApiAxiosParamCreator(configuration) {
    return {
        /**
         * Get competitor by id from Sportradar API
         * @param {string} competitorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiCompetitorCompetitorIdGet: function() {
            var _ref = _async_to_generator(function(competitorId) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return _ts_generator(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'competitorId' is not null or undefined
                    assertParamExists("apiCompetitorCompetitorIdGet", "competitorId", competitorId);
                    localVarPath = "/api/competitor/{competitor_id}".replace("{competitor_id}", encodeURIComponent(String(competitorId)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = _object_spread({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(competitorId) {
                return _ref.apply(this, arguments);
            };
        }()
    };
};
/**
 * CompetitorApi - functional programming interface
 * @export
 */ var CompetitorApiFp = function CompetitorApiFp(configuration) {
    var localVarAxiosParamCreator = CompetitorApiAxiosParamCreator(configuration);
    return {
        apiCompetitorCompetitorIdGet: /**
         * Get competitor by id from Sportradar API
         * @param {string} competitorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiCompetitorCompetitorIdGet(competitorId, options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiCompetitorCompetitorIdGet(competitorId, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["CompetitorApi.apiCompetitorCompetitorIdGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * CompetitorApi - factory interface
 * @export
 */ var CompetitorApiFactory = function CompetitorApiFactory(configuration, basePath, axios) {
    var localVarFp = CompetitorApiFp(configuration);
    return {
        /**
         * Get competitor by id from Sportradar API
         * @param {CompetitorApiApiCompetitorCompetitorIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiCompetitorCompetitorIdGet: function apiCompetitorCompetitorIdGet(requestParameters, options) {
            return localVarFp.apiCompetitorCompetitorIdGet(requestParameters.competitorId, options).then(function(request) {
                return request(axios, basePath);
            });
        }
    };
};
/**
 * CompetitorApi - object-oriented interface
 * @export
 * @class CompetitorApi
 * @extends {BaseAPI}
 */ var CompetitorApi = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(BaseAPI) {
    "use strict";
    _inherits(CompetitorApi, BaseAPI);
    var _super = _create_super(CompetitorApi);
    function CompetitorApi() {
        _class_call_check(this, CompetitorApi);
        return _super.apply(this, arguments);
    }
    var _proto = CompetitorApi.prototype;
    /**
     * Get competitor by id from Sportradar API
     * @param {CompetitorApiApiCompetitorCompetitorIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompetitorApi
     */ _proto.apiCompetitorCompetitorIdGet = function apiCompetitorCompetitorIdGet(requestParameters, options) {
        var _this = this;
        return CompetitorApiFp(this.configuration).apiCompetitorCompetitorIdGet(requestParameters.competitorId, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    return CompetitorApi;
}(BaseAPI)));

;// CONCATENATED MODULE: ./src/api/livescore/generated/api/favorites-api.ts
/* tslint:disable */ /* eslint-disable */ /**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 






// Some imports not used depending on template conditions
// @ts-ignore

// @ts-ignore

/**
 * FavoritesApi - axios parameter creator
 * @export
 */ var FavoritesApiAxiosParamCreator = function FavoritesApiAxiosParamCreator(configuration) {
    return {
        /**
         * Get favorites matches by ids
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiFavoritesGet: function() {
            var _ref = _async_to_generator(function(ids) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return _ts_generator(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'ids' is not null or undefined
                    assertParamExists("apiFavoritesGet", "ids", ids);
                    localVarPath = "/api/favorites";
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = _object_spread({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (ids !== undefined) {
                        localVarQueryParameter["ids"] = ids;
                    }
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(ids) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get favorites matches by ids
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiFavoritesIdsGet: function() {
            var _ref = _async_to_generator(function(ids) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return _ts_generator(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'ids' is not null or undefined
                    assertParamExists("apiFavoritesIdsGet", "ids", ids);
                    localVarPath = "/api/favorites/{ids}".replace("{ids}", encodeURIComponent(String(ids)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = _object_spread({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(ids) {
                return _ref.apply(this, arguments);
            };
        }()
    };
};
/**
 * FavoritesApi - functional programming interface
 * @export
 */ var FavoritesApiFp = function FavoritesApiFp(configuration) {
    var localVarAxiosParamCreator = FavoritesApiAxiosParamCreator(configuration);
    return {
        apiFavoritesGet: /**
         * Get favorites matches by ids
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiFavoritesGet(ids, options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiFavoritesGet(ids, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["FavoritesApi.apiFavoritesGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiFavoritesIdsGet: /**
         * Get favorites matches by ids
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiFavoritesIdsGet(ids, options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiFavoritesIdsGet(ids, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["FavoritesApi.apiFavoritesIdsGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * FavoritesApi - factory interface
 * @export
 */ var FavoritesApiFactory = function FavoritesApiFactory(configuration, basePath, axios) {
    var localVarFp = FavoritesApiFp(configuration);
    return {
        /**
         * Get favorites matches by ids
         * @param {FavoritesApiApiFavoritesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiFavoritesGet: function apiFavoritesGet(requestParameters, options) {
            return localVarFp.apiFavoritesGet(requestParameters.ids, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get favorites matches by ids
         * @param {FavoritesApiApiFavoritesIdsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiFavoritesIdsGet: function apiFavoritesIdsGet(requestParameters, options) {
            return localVarFp.apiFavoritesIdsGet(requestParameters.ids, options).then(function(request) {
                return request(axios, basePath);
            });
        }
    };
};
/**
 * FavoritesApi - object-oriented interface
 * @export
 * @class FavoritesApi
 * @extends {BaseAPI}
 */ var FavoritesApi = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(BaseAPI) {
    "use strict";
    _inherits(FavoritesApi, BaseAPI);
    var _super = _create_super(FavoritesApi);
    function FavoritesApi() {
        _class_call_check(this, FavoritesApi);
        return _super.apply(this, arguments);
    }
    var _proto = FavoritesApi.prototype;
    /**
     * Get favorites matches by ids
     * @param {FavoritesApiApiFavoritesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesApi
     */ _proto.apiFavoritesGet = function apiFavoritesGet(requestParameters, options) {
        var _this = this;
        return FavoritesApiFp(this.configuration).apiFavoritesGet(requestParameters.ids, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get favorites matches by ids
     * @param {FavoritesApiApiFavoritesIdsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesApi
     */ _proto.apiFavoritesIdsGet = function apiFavoritesIdsGet(requestParameters, options) {
        var _this = this;
        return FavoritesApiFp(this.configuration).apiFavoritesIdsGet(requestParameters.ids, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    return FavoritesApi;
}(BaseAPI)));

;// CONCATENATED MODULE: ./src/api/livescore/generated/api/formation-api.ts
/* tslint:disable */ /* eslint-disable */ /**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 






// Some imports not used depending on template conditions
// @ts-ignore

// @ts-ignore

/**
 * FormationApi - axios parameter creator
 * @export
 */ var FormationApiAxiosParamCreator = function FormationApiAxiosParamCreator(configuration) {
    return {
        /**
         * Get formations by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiFormationsEventIdGet: function() {
            var _ref = _async_to_generator(function(eventId) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return _ts_generator(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'eventId' is not null or undefined
                    assertParamExists("apiFormationsEventIdGet", "eventId", eventId);
                    localVarPath = "/api/formations/{event_id}".replace("{event_id}", encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = _object_spread({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(eventId) {
                return _ref.apply(this, arguments);
            };
        }()
    };
};
/**
 * FormationApi - functional programming interface
 * @export
 */ var FormationApiFp = function FormationApiFp(configuration) {
    var localVarAxiosParamCreator = FormationApiAxiosParamCreator(configuration);
    return {
        apiFormationsEventIdGet: /**
         * Get formations by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiFormationsEventIdGet(eventId, options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiFormationsEventIdGet(eventId, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["FormationApi.apiFormationsEventIdGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * FormationApi - factory interface
 * @export
 */ var FormationApiFactory = function FormationApiFactory(configuration, basePath, axios) {
    var localVarFp = FormationApiFp(configuration);
    return {
        /**
         * Get formations by id from Sportradar API
         * @param {FormationApiApiFormationsEventIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiFormationsEventIdGet: function apiFormationsEventIdGet(requestParameters, options) {
            return localVarFp.apiFormationsEventIdGet(requestParameters.eventId, options).then(function(request) {
                return request(axios, basePath);
            });
        }
    };
};
/**
 * FormationApi - object-oriented interface
 * @export
 * @class FormationApi
 * @extends {BaseAPI}
 */ var FormationApi = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(BaseAPI) {
    "use strict";
    _inherits(FormationApi, BaseAPI);
    var _super = _create_super(FormationApi);
    function FormationApi() {
        _class_call_check(this, FormationApi);
        return _super.apply(this, arguments);
    }
    var _proto = FormationApi.prototype;
    /**
     * Get formations by id from Sportradar API
     * @param {FormationApiApiFormationsEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormationApi
     */ _proto.apiFormationsEventIdGet = function apiFormationsEventIdGet(requestParameters, options) {
        var _this = this;
        return FormationApiFp(this.configuration).apiFormationsEventIdGet(requestParameters.eventId, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    return FormationApi;
}(BaseAPI)));

;// CONCATENATED MODULE: ./src/api/livescore/generated/api/h2h-api.ts
/* tslint:disable */ /* eslint-disable */ /**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 






// Some imports not used depending on template conditions
// @ts-ignore

// @ts-ignore

/**
 * H2hApi - axios parameter creator
 * @export
 */ var H2hApiAxiosParamCreator = function H2hApiAxiosParamCreator(configuration) {
    return {
        /**
         * Get h2h by id from Sportradar API
         * @param {string} homeId 
         * @param {string} awayId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiH2hGet: function() {
            var _ref = _async_to_generator(function(homeId, awayId) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return _ts_generator(this, function(_state) {
                    options = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                    // verify required parameter 'homeId' is not null or undefined
                    assertParamExists("apiH2hGet", "homeId", homeId);
                    // verify required parameter 'awayId' is not null or undefined
                    assertParamExists("apiH2hGet", "awayId", awayId);
                    localVarPath = "/api/h2h/";
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = _object_spread({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (homeId !== undefined) {
                        localVarQueryParameter["home_id"] = homeId;
                    }
                    if (awayId !== undefined) {
                        localVarQueryParameter["away_id"] = awayId;
                    }
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(homeId, awayId) {
                return _ref.apply(this, arguments);
            };
        }()
    };
};
/**
 * H2hApi - functional programming interface
 * @export
 */ var H2hApiFp = function H2hApiFp(configuration) {
    var localVarAxiosParamCreator = H2hApiAxiosParamCreator(configuration);
    return {
        apiH2hGet: /**
         * Get h2h by id from Sportradar API
         * @param {string} homeId 
         * @param {string} awayId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiH2hGet(homeId, awayId, options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiH2hGet(homeId, awayId, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["H2hApi.apiH2hGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * H2hApi - factory interface
 * @export
 */ var H2hApiFactory = function H2hApiFactory(configuration, basePath, axios) {
    var localVarFp = H2hApiFp(configuration);
    return {
        /**
         * Get h2h by id from Sportradar API
         * @param {H2hApiApiH2hGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiH2hGet: function apiH2hGet(requestParameters, options) {
            return localVarFp.apiH2hGet(requestParameters.homeId, requestParameters.awayId, options).then(function(request) {
                return request(axios, basePath);
            });
        }
    };
};
/**
 * H2hApi - object-oriented interface
 * @export
 * @class H2hApi
 * @extends {BaseAPI}
 */ var H2hApi = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(BaseAPI) {
    "use strict";
    _inherits(H2hApi, BaseAPI);
    var _super = _create_super(H2hApi);
    function H2hApi() {
        _class_call_check(this, H2hApi);
        return _super.apply(this, arguments);
    }
    var _proto = H2hApi.prototype;
    /**
     * Get h2h by id from Sportradar API
     * @param {H2hApiApiH2hGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof H2hApi
     */ _proto.apiH2hGet = function apiH2hGet(requestParameters, options) {
        var _this = this;
        return H2hApiFp(this.configuration).apiH2hGet(requestParameters.homeId, requestParameters.awayId, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    return H2hApi;
}(BaseAPI)));

;// CONCATENATED MODULE: ./src/api/livescore/generated/api/league-api.ts
/* tslint:disable */ /* eslint-disable */ /**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 






// Some imports not used depending on template conditions
// @ts-ignore

// @ts-ignore

/**
 * LeagueApi - axios parameter creator
 * @export
 */ var LeagueApiAxiosParamCreator = function LeagueApiAxiosParamCreator(configuration) {
    return {
        /**
         * Get league by ids separated by \",\" from Sportradar API
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLeagueIdsIdsGet: function() {
            var _ref = _async_to_generator(function(ids) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return _ts_generator(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'ids' is not null or undefined
                    assertParamExists("apiLeagueIdsIdsGet", "ids", ids);
                    localVarPath = "/api/league/ids/{ids}".replace("{ids}", encodeURIComponent(String(ids)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = _object_spread({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(ids) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get league by id from Sportradar API
         * @param {string} leagueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLeagueLeagueIdGet: function() {
            var _ref = _async_to_generator(function(leagueId) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return _ts_generator(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'leagueId' is not null or undefined
                    assertParamExists("apiLeagueLeagueIdGet", "leagueId", leagueId);
                    localVarPath = "/api/league/{league_id}".replace("{league_id}", encodeURIComponent(String(leagueId)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = _object_spread({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(leagueId) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get season events by id from Sportradar API
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLeagueSeasonSeasonIdEventsGet: function() {
            var _ref = _async_to_generator(function(seasonId) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return _ts_generator(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'seasonId' is not null or undefined
                    assertParamExists("apiLeagueSeasonSeasonIdEventsGet", "seasonId", seasonId);
                    localVarPath = "/api/league/season/{season_id}/events".replace("{season_id}", encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = _object_spread({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(seasonId) {
                return _ref.apply(this, arguments);
            };
        }()
    };
};
/**
 * LeagueApi - functional programming interface
 * @export
 */ var LeagueApiFp = function LeagueApiFp(configuration) {
    var localVarAxiosParamCreator = LeagueApiAxiosParamCreator(configuration);
    return {
        apiLeagueIdsIdsGet: /**
         * Get league by ids separated by \",\" from Sportradar API
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiLeagueIdsIdsGet(ids, options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiLeagueIdsIdsGet(ids, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["LeagueApi.apiLeagueIdsIdsGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiLeagueLeagueIdGet: /**
         * Get league by id from Sportradar API
         * @param {string} leagueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiLeagueLeagueIdGet(leagueId, options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiLeagueLeagueIdGet(leagueId, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["LeagueApi.apiLeagueLeagueIdGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiLeagueSeasonSeasonIdEventsGet: /**
         * Get season events by id from Sportradar API
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiLeagueSeasonSeasonIdEventsGet(seasonId, options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiLeagueSeasonSeasonIdEventsGet(seasonId, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["LeagueApi.apiLeagueSeasonSeasonIdEventsGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * LeagueApi - factory interface
 * @export
 */ var LeagueApiFactory = function LeagueApiFactory(configuration, basePath, axios) {
    var localVarFp = LeagueApiFp(configuration);
    return {
        /**
         * Get league by ids separated by \",\" from Sportradar API
         * @param {LeagueApiApiLeagueIdsIdsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLeagueIdsIdsGet: function apiLeagueIdsIdsGet(requestParameters, options) {
            return localVarFp.apiLeagueIdsIdsGet(requestParameters.ids, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get league by id from Sportradar API
         * @param {LeagueApiApiLeagueLeagueIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLeagueLeagueIdGet: function apiLeagueLeagueIdGet(requestParameters, options) {
            return localVarFp.apiLeagueLeagueIdGet(requestParameters.leagueId, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get season events by id from Sportradar API
         * @param {LeagueApiApiLeagueSeasonSeasonIdEventsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLeagueSeasonSeasonIdEventsGet: function apiLeagueSeasonSeasonIdEventsGet(requestParameters, options) {
            return localVarFp.apiLeagueSeasonSeasonIdEventsGet(requestParameters.seasonId, options).then(function(request) {
                return request(axios, basePath);
            });
        }
    };
};
/**
 * LeagueApi - object-oriented interface
 * @export
 * @class LeagueApi
 * @extends {BaseAPI}
 */ var LeagueApi = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(BaseAPI) {
    "use strict";
    _inherits(LeagueApi, BaseAPI);
    var _super = _create_super(LeagueApi);
    function LeagueApi() {
        _class_call_check(this, LeagueApi);
        return _super.apply(this, arguments);
    }
    var _proto = LeagueApi.prototype;
    /**
     * Get league by ids separated by \",\" from Sportradar API
     * @param {LeagueApiApiLeagueIdsIdsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeagueApi
     */ _proto.apiLeagueIdsIdsGet = function apiLeagueIdsIdsGet(requestParameters, options) {
        var _this = this;
        return LeagueApiFp(this.configuration).apiLeagueIdsIdsGet(requestParameters.ids, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get league by id from Sportradar API
     * @param {LeagueApiApiLeagueLeagueIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeagueApi
     */ _proto.apiLeagueLeagueIdGet = function apiLeagueLeagueIdGet(requestParameters, options) {
        var _this = this;
        return LeagueApiFp(this.configuration).apiLeagueLeagueIdGet(requestParameters.leagueId, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get season events by id from Sportradar API
     * @param {LeagueApiApiLeagueSeasonSeasonIdEventsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeagueApi
     */ _proto.apiLeagueSeasonSeasonIdEventsGet = function apiLeagueSeasonSeasonIdEventsGet(requestParameters, options) {
        var _this = this;
        return LeagueApiFp(this.configuration).apiLeagueSeasonSeasonIdEventsGet(requestParameters.seasonId, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    return LeagueApi;
}(BaseAPI)));

;// CONCATENATED MODULE: ./src/api/livescore/generated/api/livescore-api.ts
/* tslint:disable */ /* eslint-disable */ /**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 






// Some imports not used depending on template conditions
// @ts-ignore

// @ts-ignore

/**
 * LivescoreApi - axios parameter creator
 * @export
 */ var LivescoreApiAxiosParamCreator = function LivescoreApiAxiosParamCreator(configuration) {
    return {
        /**
         * Get matches for the provided date
         * @param {string} date Date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLivescoreDateGet: function() {
            var _ref = _async_to_generator(function(date) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return _ts_generator(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'date' is not null or undefined
                    assertParamExists("apiLivescoreDateGet", "date", date);
                    localVarPath = "/api/livescore/{date}".replace("{date}", encodeURIComponent(String(date)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = _object_spread({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(date) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get odds for the provided date
         * @param {string} date Date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLivescoreDateOddsGet: function() {
            var _ref = _async_to_generator(function(date) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return _ts_generator(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'date' is not null or undefined
                    assertParamExists("apiLivescoreDateOddsGet", "date", date);
                    localVarPath = "/api/livescore/{date}/odds".replace("{date}", encodeURIComponent(String(date)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = _object_spread({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(date) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get live matches
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLivescoreLiveGet: /*#__PURE__*/ _async_to_generator(function() {
            var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                localVarPath = "/api/livescore/live";
                localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                if (configuration) {
                    baseOptions = configuration.baseOptions;
                }
                localVarRequestOptions = _object_spread({
                    method: "GET"
                }, baseOptions, options);
                localVarHeaderParameter = {};
                localVarQueryParameter = {};
                setSearchParams(localVarUrlObj, localVarQueryParameter);
                headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                return [
                    2,
                    {
                        url: toPathString(localVarUrlObj),
                        options: localVarRequestOptions
                    }
                ];
            });
        })
    };
};
/**
 * LivescoreApi - functional programming interface
 * @export
 */ var LivescoreApiFp = function LivescoreApiFp(configuration) {
    var localVarAxiosParamCreator = LivescoreApiAxiosParamCreator(configuration);
    return {
        apiLivescoreDateGet: /**
         * Get matches for the provided date
         * @param {string} date Date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiLivescoreDateGet(date, options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiLivescoreDateGet(date, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["LivescoreApi.apiLivescoreDateGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiLivescoreDateOddsGet: /**
         * Get odds for the provided date
         * @param {string} date Date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiLivescoreDateOddsGet(date, options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiLivescoreDateOddsGet(date, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["LivescoreApi.apiLivescoreDateOddsGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiLivescoreLiveGet: /**
         * Get live matches
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiLivescoreLiveGet(options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiLivescoreLiveGet(options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["LivescoreApi.apiLivescoreLiveGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * LivescoreApi - factory interface
 * @export
 */ var LivescoreApiFactory = function LivescoreApiFactory(configuration, basePath, axios) {
    var localVarFp = LivescoreApiFp(configuration);
    return {
        /**
         * Get matches for the provided date
         * @param {LivescoreApiApiLivescoreDateGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLivescoreDateGet: function apiLivescoreDateGet(requestParameters, options) {
            return localVarFp.apiLivescoreDateGet(requestParameters.date, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get odds for the provided date
         * @param {LivescoreApiApiLivescoreDateOddsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLivescoreDateOddsGet: function apiLivescoreDateOddsGet(requestParameters, options) {
            return localVarFp.apiLivescoreDateOddsGet(requestParameters.date, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get live matches
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLivescoreLiveGet: function apiLivescoreLiveGet(options) {
            return localVarFp.apiLivescoreLiveGet(options).then(function(request) {
                return request(axios, basePath);
            });
        }
    };
};
/**
 * LivescoreApi - object-oriented interface
 * @export
 * @class LivescoreApi
 * @extends {BaseAPI}
 */ var LivescoreApi = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(BaseAPI) {
    "use strict";
    _inherits(LivescoreApi, BaseAPI);
    var _super = _create_super(LivescoreApi);
    function LivescoreApi() {
        _class_call_check(this, LivescoreApi);
        return _super.apply(this, arguments);
    }
    var _proto = LivescoreApi.prototype;
    /**
     * Get matches for the provided date
     * @param {LivescoreApiApiLivescoreDateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LivescoreApi
     */ _proto.apiLivescoreDateGet = function apiLivescoreDateGet(requestParameters, options) {
        var _this = this;
        return LivescoreApiFp(this.configuration).apiLivescoreDateGet(requestParameters.date, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get odds for the provided date
     * @param {LivescoreApiApiLivescoreDateOddsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LivescoreApi
     */ _proto.apiLivescoreDateOddsGet = function apiLivescoreDateOddsGet(requestParameters, options) {
        var _this = this;
        return LivescoreApiFp(this.configuration).apiLivescoreDateOddsGet(requestParameters.date, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get live matches
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LivescoreApi
     */ _proto.apiLivescoreLiveGet = function apiLivescoreLiveGet(options) {
        var _this = this;
        return LivescoreApiFp(this.configuration).apiLivescoreLiveGet(options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    return LivescoreApi;
}(BaseAPI)));

;// CONCATENATED MODULE: ./src/api/livescore/generated/api/match-api.ts
/* tslint:disable */ /* eslint-disable */ /**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 






// Some imports not used depending on template conditions
// @ts-ignore

// @ts-ignore

/**
 * MatchApi - axios parameter creator
 * @export
 */ var MatchApiAxiosParamCreator = function MatchApiAxiosParamCreator(configuration) {
    return {
        /**
         * Get match live timeline data by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiMatchEventIdAllLiveGet: function() {
            var _ref = _async_to_generator(function(eventId) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return _ts_generator(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'eventId' is not null or undefined
                    assertParamExists("apiMatchEventIdAllLiveGet", "eventId", eventId);
                    localVarPath = "/api/match/{event_id}/all/live".replace("{event_id}", encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = _object_spread({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(eventId) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get match by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiMatchEventIdGet: function() {
            var _ref = _async_to_generator(function(eventId) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return _ts_generator(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'eventId' is not null or undefined
                    assertParamExists("apiMatchEventIdGet", "eventId", eventId);
                    localVarPath = "/api/match/{event_id}".replace("{event_id}", encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = _object_spread({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(eventId) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get match live data by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiMatchEventIdLiveGet: function() {
            var _ref = _async_to_generator(function(eventId) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return _ts_generator(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'eventId' is not null or undefined
                    assertParamExists("apiMatchEventIdLiveGet", "eventId", eventId);
                    localVarPath = "/api/match/{event_id}/live".replace("{event_id}", encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = _object_spread({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(eventId) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get match preview by id from Sportradar API. It has steps: generating preview, fetching, error, success. It should be listen to the error, result and status event names.
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiMatchEventIdPreviewGet: function() {
            var _ref = _async_to_generator(function(eventId) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return _ts_generator(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'eventId' is not null or undefined
                    assertParamExists("apiMatchEventIdPreviewGet", "eventId", eventId);
                    localVarPath = "/api/match/{event_id}/preview".replace("{event_id}", encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = _object_spread({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(eventId) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get match timeline by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiMatchEventIdTimelineGet: function() {
            var _ref = _async_to_generator(function(eventId) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return _ts_generator(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'eventId' is not null or undefined
                    assertParamExists("apiMatchEventIdTimelineGet", "eventId", eventId);
                    localVarPath = "/api/match/{event_id}/timeline".replace("{event_id}", encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = _object_spread({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(eventId) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get match live timeline data by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiMatchEventIdTimelineLiveGet: function() {
            var _ref = _async_to_generator(function(eventId) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return _ts_generator(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'eventId' is not null or undefined
                    assertParamExists("apiMatchEventIdTimelineLiveGet", "eventId", eventId);
                    localVarPath = "/api/match/{event_id}/timeline/live".replace("{event_id}", encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = _object_spread({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(eventId) {
                return _ref.apply(this, arguments);
            };
        }()
    };
};
/**
 * MatchApi - functional programming interface
 * @export
 */ var MatchApiFp = function MatchApiFp(configuration) {
    var localVarAxiosParamCreator = MatchApiAxiosParamCreator(configuration);
    return {
        apiMatchEventIdAllLiveGet: /**
         * Get match live timeline data by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiMatchEventIdAllLiveGet(eventId, options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiMatchEventIdAllLiveGet(eventId, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["MatchApi.apiMatchEventIdAllLiveGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiMatchEventIdGet: /**
         * Get match by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiMatchEventIdGet(eventId, options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiMatchEventIdGet(eventId, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["MatchApi.apiMatchEventIdGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiMatchEventIdLiveGet: /**
         * Get match live data by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiMatchEventIdLiveGet(eventId, options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiMatchEventIdLiveGet(eventId, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["MatchApi.apiMatchEventIdLiveGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiMatchEventIdPreviewGet: /**
         * Get match preview by id from Sportradar API. It has steps: generating preview, fetching, error, success. It should be listen to the error, result and status event names.
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiMatchEventIdPreviewGet(eventId, options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiMatchEventIdPreviewGet(eventId, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["MatchApi.apiMatchEventIdPreviewGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiMatchEventIdTimelineGet: /**
         * Get match timeline by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiMatchEventIdTimelineGet(eventId, options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiMatchEventIdTimelineGet(eventId, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["MatchApi.apiMatchEventIdTimelineGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiMatchEventIdTimelineLiveGet: /**
         * Get match live timeline data by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiMatchEventIdTimelineLiveGet(eventId, options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiMatchEventIdTimelineLiveGet(eventId, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["MatchApi.apiMatchEventIdTimelineLiveGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * MatchApi - factory interface
 * @export
 */ var MatchApiFactory = function MatchApiFactory(configuration, basePath, axios) {
    var localVarFp = MatchApiFp(configuration);
    return {
        /**
         * Get match live timeline data by id from Sportradar API
         * @param {MatchApiApiMatchEventIdAllLiveGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiMatchEventIdAllLiveGet: function apiMatchEventIdAllLiveGet(requestParameters, options) {
            return localVarFp.apiMatchEventIdAllLiveGet(requestParameters.eventId, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get match by id from Sportradar API
         * @param {MatchApiApiMatchEventIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiMatchEventIdGet: function apiMatchEventIdGet(requestParameters, options) {
            return localVarFp.apiMatchEventIdGet(requestParameters.eventId, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get match live data by id from Sportradar API
         * @param {MatchApiApiMatchEventIdLiveGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiMatchEventIdLiveGet: function apiMatchEventIdLiveGet(requestParameters, options) {
            return localVarFp.apiMatchEventIdLiveGet(requestParameters.eventId, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get match preview by id from Sportradar API. It has steps: generating preview, fetching, error, success. It should be listen to the error, result and status event names.
         * @param {MatchApiApiMatchEventIdPreviewGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiMatchEventIdPreviewGet: function apiMatchEventIdPreviewGet(requestParameters, options) {
            return localVarFp.apiMatchEventIdPreviewGet(requestParameters.eventId, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get match timeline by id from Sportradar API
         * @param {MatchApiApiMatchEventIdTimelineGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiMatchEventIdTimelineGet: function apiMatchEventIdTimelineGet(requestParameters, options) {
            return localVarFp.apiMatchEventIdTimelineGet(requestParameters.eventId, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get match live timeline data by id from Sportradar API
         * @param {MatchApiApiMatchEventIdTimelineLiveGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiMatchEventIdTimelineLiveGet: function apiMatchEventIdTimelineLiveGet(requestParameters, options) {
            return localVarFp.apiMatchEventIdTimelineLiveGet(requestParameters.eventId, options).then(function(request) {
                return request(axios, basePath);
            });
        }
    };
};
/**
 * MatchApi - object-oriented interface
 * @export
 * @class MatchApi
 * @extends {BaseAPI}
 */ var MatchApi = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(BaseAPI) {
    "use strict";
    _inherits(MatchApi, BaseAPI);
    var _super = _create_super(MatchApi);
    function MatchApi() {
        _class_call_check(this, MatchApi);
        return _super.apply(this, arguments);
    }
    var _proto = MatchApi.prototype;
    /**
     * Get match live timeline data by id from Sportradar API
     * @param {MatchApiApiMatchEventIdAllLiveGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchApi
     */ _proto.apiMatchEventIdAllLiveGet = function apiMatchEventIdAllLiveGet(requestParameters, options) {
        var _this = this;
        return MatchApiFp(this.configuration).apiMatchEventIdAllLiveGet(requestParameters.eventId, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get match by id from Sportradar API
     * @param {MatchApiApiMatchEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchApi
     */ _proto.apiMatchEventIdGet = function apiMatchEventIdGet(requestParameters, options) {
        var _this = this;
        return MatchApiFp(this.configuration).apiMatchEventIdGet(requestParameters.eventId, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get match live data by id from Sportradar API
     * @param {MatchApiApiMatchEventIdLiveGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchApi
     */ _proto.apiMatchEventIdLiveGet = function apiMatchEventIdLiveGet(requestParameters, options) {
        var _this = this;
        return MatchApiFp(this.configuration).apiMatchEventIdLiveGet(requestParameters.eventId, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get match preview by id from Sportradar API. It has steps: generating preview, fetching, error, success. It should be listen to the error, result and status event names.
     * @param {MatchApiApiMatchEventIdPreviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchApi
     */ _proto.apiMatchEventIdPreviewGet = function apiMatchEventIdPreviewGet(requestParameters, options) {
        var _this = this;
        return MatchApiFp(this.configuration).apiMatchEventIdPreviewGet(requestParameters.eventId, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get match timeline by id from Sportradar API
     * @param {MatchApiApiMatchEventIdTimelineGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchApi
     */ _proto.apiMatchEventIdTimelineGet = function apiMatchEventIdTimelineGet(requestParameters, options) {
        var _this = this;
        return MatchApiFp(this.configuration).apiMatchEventIdTimelineGet(requestParameters.eventId, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get match live timeline data by id from Sportradar API
     * @param {MatchApiApiMatchEventIdTimelineLiveGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchApi
     */ _proto.apiMatchEventIdTimelineLiveGet = function apiMatchEventIdTimelineLiveGet(requestParameters, options) {
        var _this = this;
        return MatchApiFp(this.configuration).apiMatchEventIdTimelineLiveGet(requestParameters.eventId, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    return MatchApi;
}(BaseAPI)));

;// CONCATENATED MODULE: ./src/api/livescore/generated/api/matches-api.ts
/* tslint:disable */ /* eslint-disable */ /**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 






// Some imports not used depending on template conditions
// @ts-ignore

// @ts-ignore

/**
 * MatchesApi - axios parameter creator
 * @export
 */ var MatchesApiAxiosParamCreator = function MatchesApiAxiosParamCreator(configuration) {
    return {
        /**
         * Get matches for the provided date
         * @param {string} date Date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLivescoreDateGet: function() {
            var _ref = _async_to_generator(function(date) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return _ts_generator(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'date' is not null or undefined
                    assertParamExists("apiLivescoreDateGet", "date", date);
                    localVarPath = "/api/livescore/{date}".replace("{date}", encodeURIComponent(String(date)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = _object_spread({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(date) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get odds for the provided date
         * @param {string} date Date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLivescoreDateOddsGet: function() {
            var _ref = _async_to_generator(function(date) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return _ts_generator(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'date' is not null or undefined
                    assertParamExists("apiLivescoreDateOddsGet", "date", date);
                    localVarPath = "/api/livescore/{date}/odds".replace("{date}", encodeURIComponent(String(date)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = _object_spread({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(date) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get live matches
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLivescoreLiveGet: /*#__PURE__*/ _async_to_generator(function() {
            var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                localVarPath = "/api/livescore/live";
                localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                if (configuration) {
                    baseOptions = configuration.baseOptions;
                }
                localVarRequestOptions = _object_spread({
                    method: "GET"
                }, baseOptions, options);
                localVarHeaderParameter = {};
                localVarQueryParameter = {};
                setSearchParams(localVarUrlObj, localVarQueryParameter);
                headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                return [
                    2,
                    {
                        url: toPathString(localVarUrlObj),
                        options: localVarRequestOptions
                    }
                ];
            });
        }),
        /**
         * Get upcoming matches for the next 3 days from configured leagues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiUpcomingMatchesGet: /*#__PURE__*/ _async_to_generator(function() {
            var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                localVarPath = "/api/upcoming-matches";
                localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                if (configuration) {
                    baseOptions = configuration.baseOptions;
                }
                localVarRequestOptions = _object_spread({
                    method: "GET"
                }, baseOptions, options);
                localVarHeaderParameter = {};
                localVarQueryParameter = {};
                setSearchParams(localVarUrlObj, localVarQueryParameter);
                headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                return [
                    2,
                    {
                        url: toPathString(localVarUrlObj),
                        options: localVarRequestOptions
                    }
                ];
            });
        }),
        /**
         * Upcoming matches ids for today and yesterday from all leagues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiUpcomingMatchesIdsGet: /*#__PURE__*/ _async_to_generator(function() {
            var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                localVarPath = "/api/upcoming-matches/ids";
                localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                if (configuration) {
                    baseOptions = configuration.baseOptions;
                }
                localVarRequestOptions = _object_spread({
                    method: "GET"
                }, baseOptions, options);
                localVarHeaderParameter = {};
                localVarQueryParameter = {};
                setSearchParams(localVarUrlObj, localVarQueryParameter);
                headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                return [
                    2,
                    {
                        url: toPathString(localVarUrlObj),
                        options: localVarRequestOptions
                    }
                ];
            });
        }),
        /**
         * Get upcoming matches for the next week from configured leagues. This route is deprecated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiUpcomingMatchesOldGet: /*#__PURE__*/ _async_to_generator(function() {
            var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                localVarPath = "/api/upcoming-matches-old";
                localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                if (configuration) {
                    baseOptions = configuration.baseOptions;
                }
                localVarRequestOptions = _object_spread({
                    method: "GET"
                }, baseOptions, options);
                localVarHeaderParameter = {};
                localVarQueryParameter = {};
                setSearchParams(localVarUrlObj, localVarQueryParameter);
                headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                return [
                    2,
                    {
                        url: toPathString(localVarUrlObj),
                        options: localVarRequestOptions
                    }
                ];
            });
        })
    };
};
/**
 * MatchesApi - functional programming interface
 * @export
 */ var MatchesApiFp = function MatchesApiFp(configuration) {
    var localVarAxiosParamCreator = MatchesApiAxiosParamCreator(configuration);
    return {
        apiLivescoreDateGet: /**
         * Get matches for the provided date
         * @param {string} date Date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiLivescoreDateGet(date, options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiLivescoreDateGet(date, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["MatchesApi.apiLivescoreDateGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiLivescoreDateOddsGet: /**
         * Get odds for the provided date
         * @param {string} date Date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiLivescoreDateOddsGet(date, options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiLivescoreDateOddsGet(date, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["MatchesApi.apiLivescoreDateOddsGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiLivescoreLiveGet: /**
         * Get live matches
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiLivescoreLiveGet(options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiLivescoreLiveGet(options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["MatchesApi.apiLivescoreLiveGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiUpcomingMatchesGet: /**
         * Get upcoming matches for the next 3 days from configured leagues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiUpcomingMatchesGet(options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiUpcomingMatchesGet(options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["MatchesApi.apiUpcomingMatchesGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiUpcomingMatchesIdsGet: /**
         * Upcoming matches ids for today and yesterday from all leagues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiUpcomingMatchesIdsGet(options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiUpcomingMatchesIdsGet(options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["MatchesApi.apiUpcomingMatchesIdsGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiUpcomingMatchesOldGet: /**
         * Get upcoming matches for the next week from configured leagues. This route is deprecated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiUpcomingMatchesOldGet(options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiUpcomingMatchesOldGet(options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["MatchesApi.apiUpcomingMatchesOldGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * MatchesApi - factory interface
 * @export
 */ var MatchesApiFactory = function MatchesApiFactory(configuration, basePath, axios) {
    var localVarFp = MatchesApiFp(configuration);
    return {
        /**
         * Get matches for the provided date
         * @param {MatchesApiApiLivescoreDateGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLivescoreDateGet: function apiLivescoreDateGet(requestParameters, options) {
            return localVarFp.apiLivescoreDateGet(requestParameters.date, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get odds for the provided date
         * @param {MatchesApiApiLivescoreDateOddsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLivescoreDateOddsGet: function apiLivescoreDateOddsGet(requestParameters, options) {
            return localVarFp.apiLivescoreDateOddsGet(requestParameters.date, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get live matches
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiLivescoreLiveGet: function apiLivescoreLiveGet(options) {
            return localVarFp.apiLivescoreLiveGet(options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get upcoming matches for the next 3 days from configured leagues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiUpcomingMatchesGet: function apiUpcomingMatchesGet(options) {
            return localVarFp.apiUpcomingMatchesGet(options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Upcoming matches ids for today and yesterday from all leagues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiUpcomingMatchesIdsGet: function apiUpcomingMatchesIdsGet(options) {
            return localVarFp.apiUpcomingMatchesIdsGet(options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get upcoming matches for the next week from configured leagues. This route is deprecated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiUpcomingMatchesOldGet: function apiUpcomingMatchesOldGet(options) {
            return localVarFp.apiUpcomingMatchesOldGet(options).then(function(request) {
                return request(axios, basePath);
            });
        }
    };
};
/**
 * MatchesApi - object-oriented interface
 * @export
 * @class MatchesApi
 * @extends {BaseAPI}
 */ var MatchesApi = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(BaseAPI) {
    "use strict";
    _inherits(MatchesApi, BaseAPI);
    var _super = _create_super(MatchesApi);
    function MatchesApi() {
        _class_call_check(this, MatchesApi);
        return _super.apply(this, arguments);
    }
    var _proto = MatchesApi.prototype;
    /**
     * Get matches for the provided date
     * @param {MatchesApiApiLivescoreDateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */ _proto.apiLivescoreDateGet = function apiLivescoreDateGet(requestParameters, options) {
        var _this = this;
        return MatchesApiFp(this.configuration).apiLivescoreDateGet(requestParameters.date, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get odds for the provided date
     * @param {MatchesApiApiLivescoreDateOddsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */ _proto.apiLivescoreDateOddsGet = function apiLivescoreDateOddsGet(requestParameters, options) {
        var _this = this;
        return MatchesApiFp(this.configuration).apiLivescoreDateOddsGet(requestParameters.date, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get live matches
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */ _proto.apiLivescoreLiveGet = function apiLivescoreLiveGet(options) {
        var _this = this;
        return MatchesApiFp(this.configuration).apiLivescoreLiveGet(options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get upcoming matches for the next 3 days from configured leagues
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */ _proto.apiUpcomingMatchesGet = function apiUpcomingMatchesGet(options) {
        var _this = this;
        return MatchesApiFp(this.configuration).apiUpcomingMatchesGet(options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Upcoming matches ids for today and yesterday from all leagues
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */ _proto.apiUpcomingMatchesIdsGet = function apiUpcomingMatchesIdsGet(options) {
        var _this = this;
        return MatchesApiFp(this.configuration).apiUpcomingMatchesIdsGet(options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get upcoming matches for the next week from configured leagues. This route is deprecated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */ _proto.apiUpcomingMatchesOldGet = function apiUpcomingMatchesOldGet(options) {
        var _this = this;
        return MatchesApiFp(this.configuration).apiUpcomingMatchesOldGet(options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    return MatchesApi;
}(BaseAPI)));

;// CONCATENATED MODULE: ./src/api/livescore/generated/api/player-api.ts
/* tslint:disable */ /* eslint-disable */ /**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 






// Some imports not used depending on template conditions
// @ts-ignore

// @ts-ignore

/**
 * PlayerApi - axios parameter creator
 * @export
 */ var PlayerApiAxiosParamCreator = function PlayerApiAxiosParamCreator(configuration) {
    return {
        /**
         * Get player by id from Sportradar API
         * @param {string} playerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiPlayerPlayerIdGet: function() {
            var _ref = _async_to_generator(function(playerId) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return _ts_generator(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'playerId' is not null or undefined
                    assertParamExists("apiPlayerPlayerIdGet", "playerId", playerId);
                    localVarPath = "/api/player/{player_id}".replace("{player_id}", encodeURIComponent(String(playerId)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = _object_spread({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(playerId) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Get player statistics by id from Sportradar API
         * @param {string} playerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiPlayerPlayerIdStatsGet: function() {
            var _ref = _async_to_generator(function(playerId) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return _ts_generator(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'playerId' is not null or undefined
                    assertParamExists("apiPlayerPlayerIdStatsGet", "playerId", playerId);
                    localVarPath = "/api/player/{player_id}/stats".replace("{player_id}", encodeURIComponent(String(playerId)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = _object_spread({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(playerId) {
                return _ref.apply(this, arguments);
            };
        }()
    };
};
/**
 * PlayerApi - functional programming interface
 * @export
 */ var PlayerApiFp = function PlayerApiFp(configuration) {
    var localVarAxiosParamCreator = PlayerApiAxiosParamCreator(configuration);
    return {
        apiPlayerPlayerIdGet: /**
         * Get player by id from Sportradar API
         * @param {string} playerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiPlayerPlayerIdGet(playerId, options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiPlayerPlayerIdGet(playerId, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["PlayerApi.apiPlayerPlayerIdGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiPlayerPlayerIdStatsGet: /**
         * Get player statistics by id from Sportradar API
         * @param {string} playerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiPlayerPlayerIdStatsGet(playerId, options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiPlayerPlayerIdStatsGet(playerId, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["PlayerApi.apiPlayerPlayerIdStatsGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * PlayerApi - factory interface
 * @export
 */ var PlayerApiFactory = function PlayerApiFactory(configuration, basePath, axios) {
    var localVarFp = PlayerApiFp(configuration);
    return {
        /**
         * Get player by id from Sportradar API
         * @param {PlayerApiApiPlayerPlayerIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiPlayerPlayerIdGet: function apiPlayerPlayerIdGet(requestParameters, options) {
            return localVarFp.apiPlayerPlayerIdGet(requestParameters.playerId, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get player statistics by id from Sportradar API
         * @param {PlayerApiApiPlayerPlayerIdStatsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiPlayerPlayerIdStatsGet: function apiPlayerPlayerIdStatsGet(requestParameters, options) {
            return localVarFp.apiPlayerPlayerIdStatsGet(requestParameters.playerId, options).then(function(request) {
                return request(axios, basePath);
            });
        }
    };
};
/**
 * PlayerApi - object-oriented interface
 * @export
 * @class PlayerApi
 * @extends {BaseAPI}
 */ var PlayerApi = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(BaseAPI) {
    "use strict";
    _inherits(PlayerApi, BaseAPI);
    var _super = _create_super(PlayerApi);
    function PlayerApi() {
        _class_call_check(this, PlayerApi);
        return _super.apply(this, arguments);
    }
    var _proto = PlayerApi.prototype;
    /**
     * Get player by id from Sportradar API
     * @param {PlayerApiApiPlayerPlayerIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApi
     */ _proto.apiPlayerPlayerIdGet = function apiPlayerPlayerIdGet(requestParameters, options) {
        var _this = this;
        return PlayerApiFp(this.configuration).apiPlayerPlayerIdGet(requestParameters.playerId, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get player statistics by id from Sportradar API
     * @param {PlayerApiApiPlayerPlayerIdStatsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApi
     */ _proto.apiPlayerPlayerIdStatsGet = function apiPlayerPlayerIdStatsGet(requestParameters, options) {
        var _this = this;
        return PlayerApiFp(this.configuration).apiPlayerPlayerIdStatsGet(requestParameters.playerId, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    return PlayerApi;
}(BaseAPI)));

;// CONCATENATED MODULE: ./src/api/livescore/generated/api/players-api.ts
/* tslint:disable */ /* eslint-disable */ /**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 






// Some imports not used depending on template conditions
// @ts-ignore

// @ts-ignore

/**
 * PlayersApi - axios parameter creator
 * @export
 */ var PlayersApiAxiosParamCreator = function PlayersApiAxiosParamCreator(configuration) {
    return {
        /**
         * Get all players
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiPlayersGet: /*#__PURE__*/ _async_to_generator(function() {
            var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                localVarPath = "/api/players";
                localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                if (configuration) {
                    baseOptions = configuration.baseOptions;
                }
                localVarRequestOptions = _object_spread({
                    method: "GET"
                }, baseOptions, options);
                localVarHeaderParameter = {};
                localVarQueryParameter = {};
                setSearchParams(localVarUrlObj, localVarQueryParameter);
                headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                return [
                    2,
                    {
                        url: toPathString(localVarUrlObj),
                        options: localVarRequestOptions
                    }
                ];
            });
        }),
        /**
         * Get favorites players by ids
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiPlayersIdsGet: function() {
            var _ref = _async_to_generator(function(ids) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return _ts_generator(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'ids' is not null or undefined
                    assertParamExists("apiPlayersIdsGet", "ids", ids);
                    localVarPath = "/api/players/{ids}".replace("{ids}", encodeURIComponent(String(ids)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = _object_spread({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(ids) {
                return _ref.apply(this, arguments);
            };
        }()
    };
};
/**
 * PlayersApi - functional programming interface
 * @export
 */ var PlayersApiFp = function PlayersApiFp(configuration) {
    var localVarAxiosParamCreator = PlayersApiAxiosParamCreator(configuration);
    return {
        apiPlayersGet: /**
         * Get all players
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiPlayersGet(options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiPlayersGet(options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["PlayersApi.apiPlayersGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiPlayersIdsGet: /**
         * Get favorites players by ids
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiPlayersIdsGet(ids, options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiPlayersIdsGet(ids, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["PlayersApi.apiPlayersIdsGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * PlayersApi - factory interface
 * @export
 */ var PlayersApiFactory = function PlayersApiFactory(configuration, basePath, axios) {
    var localVarFp = PlayersApiFp(configuration);
    return {
        /**
         * Get all players
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiPlayersGet: function apiPlayersGet(options) {
            return localVarFp.apiPlayersGet(options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Get favorites players by ids
         * @param {PlayersApiApiPlayersIdsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiPlayersIdsGet: function apiPlayersIdsGet(requestParameters, options) {
            return localVarFp.apiPlayersIdsGet(requestParameters.ids, options).then(function(request) {
                return request(axios, basePath);
            });
        }
    };
};
/**
 * PlayersApi - object-oriented interface
 * @export
 * @class PlayersApi
 * @extends {BaseAPI}
 */ var PlayersApi = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(BaseAPI) {
    "use strict";
    _inherits(PlayersApi, BaseAPI);
    var _super = _create_super(PlayersApi);
    function PlayersApi() {
        _class_call_check(this, PlayersApi);
        return _super.apply(this, arguments);
    }
    var _proto = PlayersApi.prototype;
    /**
     * Get all players
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayersApi
     */ _proto.apiPlayersGet = function apiPlayersGet(options) {
        var _this = this;
        return PlayersApiFp(this.configuration).apiPlayersGet(options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Get favorites players by ids
     * @param {PlayersApiApiPlayersIdsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayersApi
     */ _proto.apiPlayersIdsGet = function apiPlayersIdsGet(requestParameters, options) {
        var _this = this;
        return PlayersApiFp(this.configuration).apiPlayersIdsGet(requestParameters.ids, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    return PlayersApi;
}(BaseAPI)));

;// CONCATENATED MODULE: ./src/api/livescore/generated/api/search-api.ts
/* tslint:disable */ /* eslint-disable */ /**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 






// Some imports not used depending on template conditions
// @ts-ignore

// @ts-ignore

/**
 * SearchApi - axios parameter creator
 * @export
 */ var SearchApiAxiosParamCreator = function SearchApiAxiosParamCreator(configuration) {
    return {
        /**
         * Search for players, teams, competitions
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiSearchGet: function() {
            var _ref = _async_to_generator(function(q) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return _ts_generator(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'q' is not null or undefined
                    assertParamExists("apiSearchGet", "q", q);
                    localVarPath = "/api/search";
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = _object_spread({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (q !== undefined) {
                        localVarQueryParameter["q"] = q;
                    }
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(q) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Search for leagues
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiSearchLeaguesGet: function() {
            var _ref = _async_to_generator(function(q) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return _ts_generator(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'q' is not null or undefined
                    assertParamExists("apiSearchLeaguesGet", "q", q);
                    localVarPath = "/api/search/leagues";
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = _object_spread({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (q !== undefined) {
                        localVarQueryParameter["q"] = q;
                    }
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(q) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         * Search for players
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiSearchPlayersGet: function() {
            var _ref = _async_to_generator(function(q) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return _ts_generator(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'q' is not null or undefined
                    assertParamExists("apiSearchPlayersGet", "q", q);
                    localVarPath = "/api/search/players";
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = _object_spread({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (q !== undefined) {
                        localVarQueryParameter["q"] = q;
                    }
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(q) {
                return _ref.apply(this, arguments);
            };
        }()
    };
};
/**
 * SearchApi - functional programming interface
 * @export
 */ var SearchApiFp = function SearchApiFp(configuration) {
    var localVarAxiosParamCreator = SearchApiAxiosParamCreator(configuration);
    return {
        apiSearchGet: /**
         * Search for players, teams, competitions
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiSearchGet(q, options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiSearchGet(q, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["SearchApi.apiSearchGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiSearchLeaguesGet: /**
         * Search for leagues
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiSearchLeaguesGet(q, options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiSearchLeaguesGet(q, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["SearchApi.apiSearchLeaguesGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        },
        apiSearchPlayersGet: /**
         * Search for players
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiSearchPlayersGet(q, options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiSearchPlayersGet(q, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["SearchApi.apiSearchPlayersGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * SearchApi - factory interface
 * @export
 */ var SearchApiFactory = function SearchApiFactory(configuration, basePath, axios) {
    var localVarFp = SearchApiFp(configuration);
    return {
        /**
         * Search for players, teams, competitions
         * @param {SearchApiApiSearchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiSearchGet: function apiSearchGet(requestParameters, options) {
            return localVarFp.apiSearchGet(requestParameters.q, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Search for leagues
         * @param {SearchApiApiSearchLeaguesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiSearchLeaguesGet: function apiSearchLeaguesGet(requestParameters, options) {
            return localVarFp.apiSearchLeaguesGet(requestParameters.q, options).then(function(request) {
                return request(axios, basePath);
            });
        },
        /**
         * Search for players
         * @param {SearchApiApiSearchPlayersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiSearchPlayersGet: function apiSearchPlayersGet(requestParameters, options) {
            return localVarFp.apiSearchPlayersGet(requestParameters.q, options).then(function(request) {
                return request(axios, basePath);
            });
        }
    };
};
/**
 * SearchApi - object-oriented interface
 * @export
 * @class SearchApi
 * @extends {BaseAPI}
 */ var SearchApi = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(BaseAPI) {
    "use strict";
    _inherits(SearchApi, BaseAPI);
    var _super = _create_super(SearchApi);
    function SearchApi() {
        _class_call_check(this, SearchApi);
        return _super.apply(this, arguments);
    }
    var _proto = SearchApi.prototype;
    /**
     * Search for players, teams, competitions
     * @param {SearchApiApiSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */ _proto.apiSearchGet = function apiSearchGet(requestParameters, options) {
        var _this = this;
        return SearchApiFp(this.configuration).apiSearchGet(requestParameters.q, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Search for leagues
     * @param {SearchApiApiSearchLeaguesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */ _proto.apiSearchLeaguesGet = function apiSearchLeaguesGet(requestParameters, options) {
        var _this = this;
        return SearchApiFp(this.configuration).apiSearchLeaguesGet(requestParameters.q, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    /**
     * Search for players
     * @param {SearchApiApiSearchPlayersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */ _proto.apiSearchPlayersGet = function apiSearchPlayersGet(requestParameters, options) {
        var _this = this;
        return SearchApiFp(this.configuration).apiSearchPlayersGet(requestParameters.q, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    return SearchApi;
}(BaseAPI)));

;// CONCATENATED MODULE: ./src/api/livescore/generated/api/season-table-api.ts
/* tslint:disable */ /* eslint-disable */ /**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 






// Some imports not used depending on template conditions
// @ts-ignore

// @ts-ignore

/**
 * SeasonTableApi - axios parameter creator
 * @export
 */ var SeasonTableApiAxiosParamCreator = function SeasonTableApiAxiosParamCreator(configuration) {
    return {
        /**
         * Get league table by id from Sportradar API
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiSeasonTableSeasonIdGet: function() {
            var _ref = _async_to_generator(function(seasonId) {
                var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                var _arguments = arguments;
                return _ts_generator(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // verify required parameter 'seasonId' is not null or undefined
                    assertParamExists("apiSeasonTableSeasonIdGet", "seasonId", seasonId);
                    localVarPath = "/api/season-table/{season_id}".replace("{season_id}", encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = _object_spread({
                        method: "GET"
                    }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [
                        2,
                        {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions
                        }
                    ];
                });
            });
            return function(seasonId) {
                return _ref.apply(this, arguments);
            };
        }()
    };
};
/**
 * SeasonTableApi - functional programming interface
 * @export
 */ var SeasonTableApiFp = function SeasonTableApiFp(configuration) {
    var localVarAxiosParamCreator = SeasonTableApiAxiosParamCreator(configuration);
    return {
        apiSeasonTableSeasonIdGet: /**
         * Get league table by id from Sportradar API
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiSeasonTableSeasonIdGet(seasonId, options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiSeasonTableSeasonIdGet(seasonId, options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["SeasonTableApi.apiSeasonTableSeasonIdGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * SeasonTableApi - factory interface
 * @export
 */ var SeasonTableApiFactory = function SeasonTableApiFactory(configuration, basePath, axios) {
    var localVarFp = SeasonTableApiFp(configuration);
    return {
        /**
         * Get league table by id from Sportradar API
         * @param {SeasonTableApiApiSeasonTableSeasonIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiSeasonTableSeasonIdGet: function apiSeasonTableSeasonIdGet(requestParameters, options) {
            return localVarFp.apiSeasonTableSeasonIdGet(requestParameters.seasonId, options).then(function(request) {
                return request(axios, basePath);
            });
        }
    };
};
/**
 * SeasonTableApi - object-oriented interface
 * @export
 * @class SeasonTableApi
 * @extends {BaseAPI}
 */ var SeasonTableApi = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(BaseAPI) {
    "use strict";
    _inherits(SeasonTableApi, BaseAPI);
    var _super = _create_super(SeasonTableApi);
    function SeasonTableApi() {
        _class_call_check(this, SeasonTableApi);
        return _super.apply(this, arguments);
    }
    var _proto = SeasonTableApi.prototype;
    /**
     * Get league table by id from Sportradar API
     * @param {SeasonTableApiApiSeasonTableSeasonIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonTableApi
     */ _proto.apiSeasonTableSeasonIdGet = function apiSeasonTableSeasonIdGet(requestParameters, options) {
        var _this = this;
        return SeasonTableApiFp(this.configuration).apiSeasonTableSeasonIdGet(requestParameters.seasonId, options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    return SeasonTableApi;
}(BaseAPI)));

;// CONCATENATED MODULE: ./src/api/livescore/generated/api/teams-api.ts
/* tslint:disable */ /* eslint-disable */ /**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 






// Some imports not used depending on template conditions
// @ts-ignore

// @ts-ignore

/**
 * TeamsApi - axios parameter creator
 * @export
 */ var TeamsApiAxiosParamCreator = function TeamsApiAxiosParamCreator(configuration) {
    return {
        /**
         * Get all teams from Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiTeamsGet: /*#__PURE__*/ _async_to_generator(function() {
            var options, localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                localVarPath = "/api/teams";
                localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                if (configuration) {
                    baseOptions = configuration.baseOptions;
                }
                localVarRequestOptions = _object_spread({
                    method: "GET"
                }, baseOptions, options);
                localVarHeaderParameter = {};
                localVarQueryParameter = {};
                setSearchParams(localVarUrlObj, localVarQueryParameter);
                headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                localVarRequestOptions.headers = _object_spread({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                return [
                    2,
                    {
                        url: toPathString(localVarUrlObj),
                        options: localVarRequestOptions
                    }
                ];
            });
        })
    };
};
/**
 * TeamsApi - functional programming interface
 * @export
 */ var TeamsApiFp = function TeamsApiFp(configuration) {
    var localVarAxiosParamCreator = TeamsApiAxiosParamCreator(configuration);
    return {
        apiTeamsGet: /**
         * Get all teams from Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ function apiTeamsGet(options) {
            return _async_to_generator(function() {
                var ref, ref1, localVarAxiosArgs, ref2, localVarOperationServerIndex, localVarOperationServerBasePath;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localVarAxiosParamCreator.apiTeamsGet(options)
                            ];
                        case 1:
                            localVarAxiosArgs = _state.sent();
                            localVarOperationServerIndex = (ref2 = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && ref2 !== void 0 ? ref2 : 0;
                            localVarOperationServerBasePath = (ref = operationServerMap["TeamsApi.apiTeamsGet"]) === null || ref === void 0 ? void 0 : (ref1 = ref[localVarOperationServerIndex]) === null || ref1 === void 0 ? void 0 : ref1.url;
                            return [
                                2,
                                function(axios, basePath) {
                                    return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
                                }
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * TeamsApi - factory interface
 * @export
 */ var TeamsApiFactory = function TeamsApiFactory(configuration, basePath, axios) {
    var localVarFp = TeamsApiFp(configuration);
    return {
        /**
         * Get all teams from Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ apiTeamsGet: function apiTeamsGet(options) {
            return localVarFp.apiTeamsGet(options).then(function(request) {
                return request(axios, basePath);
            });
        }
    };
};
/**
 * TeamsApi - object-oriented interface
 * @export
 * @class TeamsApi
 * @extends {BaseAPI}
 */ var TeamsApi = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(BaseAPI) {
    "use strict";
    _inherits(TeamsApi, BaseAPI);
    var _super = _create_super(TeamsApi);
    function TeamsApi() {
        _class_call_check(this, TeamsApi);
        return _super.apply(this, arguments);
    }
    var _proto = TeamsApi.prototype;
    /**
     * Get all teams from Sportradar API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */ _proto.apiTeamsGet = function apiTeamsGet(options) {
        var _this = this;
        return TeamsApiFp(this.configuration).apiTeamsGet(options).then(function(request) {
            return request(_this.axios, _this.basePath);
        });
    };
    return TeamsApi;
}(BaseAPI)));

;// CONCATENATED MODULE: ./src/api/livescore/generated/api.ts
/* tslint:disable */ /* eslint-disable */ /**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 















;// CONCATENATED MODULE: ./src/api/livescore/generated/configuration.ts
/* tslint:disable */ /* eslint-disable */ /**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 


var Configuration = /*#__PURE__*/ function() {
    "use strict";
    function Configuration() {
        var param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0,src_class_call_check/* default */.Z)(this, Configuration);
        var ref;
        this.apiKey = param.apiKey;
        this.username = param.username;
        this.password = param.password;
        this.accessToken = param.accessToken;
        this.basePath = param.basePath;
        this.serverIndex = param.serverIndex;
        this.baseOptions = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, param.baseOptions), {
            headers: (0,src_object_spread/* default */.Z)({}, (ref = param.baseOptions) === null || ref === void 0 ? void 0 : ref.headers)
        });
        this.formDataCtor = param.formDataCtor;
    }
    var _proto = Configuration.prototype;
    /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param mime - MIME (Multipurpose Internet Mail Extensions)
     * @return True if the given MIME is JSON, false otherwise.
     */ _proto.isJsonMime = function isJsonMime(mime) {
        var jsonMime = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
        return mime !== null && (jsonMime.test(mime) || mime.toLowerCase() === "application/json-patch+json");
    };
    return Configuration;
}();

;// CONCATENATED MODULE: ./src/api/livescore/generated/index.ts
/* tslint:disable */ /* eslint-disable */ /**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 



;// CONCATENATED MODULE: ./src/api/livescore/client.ts

var config = new Configuration({
    basePath: "https://fangoltestscore.fangol.pl"
});
var livescoreClient = new ApiApi(config);


/***/ }),

/***/ 42500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GP": function() { return /* reexport safe */ _user__WEBPACK_IMPORTED_MODULE_0__.GP; },
/* harmony export */   "M9": function() { return /* reexport safe */ _user__WEBPACK_IMPORTED_MODULE_0__.M9; },
/* harmony export */   "Yy": function() { return /* reexport safe */ _user__WEBPACK_IMPORTED_MODULE_0__.Yy; },
/* harmony export */   "rK": function() { return /* reexport safe */ _user__WEBPACK_IMPORTED_MODULE_0__.rK; }
/* harmony export */ });
/* harmony import */ var _user__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42698);




/***/ }),

/***/ 15645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ CompetitorElement; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _heroicons_react_24_solid__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96445);
/* harmony import */ var _utils_cn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72802);
/* harmony import */ var _LivescoreFavoriteToggler_LivescoreFavoriteToggler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57591);
/* harmony import */ var _context_LivescoreLayoutContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95599);
/* harmony import */ var _LivescoreFavoriteCircleToggler_LivescoreFavoriteCircleToggler__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49359);









function toPolishGender(gender) {
    if (gender === "male") return "Mężczyzni";
    if (gender === "female") return "Kobiety";
    return null;
}
var CompetitorElement = function(_param) {
    var team = _param.team, className = _param.className, _addLink = _param.addLink, addLink = _addLink === void 0 ? false : _addLink, _icon = _param.icon, icon = _icon === void 0 ? "star" : _icon, _size = _param.size, size = _size === void 0 ? "large" : _size, highlight = _param.highlight, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "team",
        "className",
        "addLink",
        "icon",
        "size",
        "highlight"
    ]);
    var ref = (0,_context_LivescoreLayoutContext__WEBPACK_IMPORTED_MODULE_2__/* .useLivescoreLayout */ .z)(), favoriteCompetitors = ref.favoriteCompetitors, toggleFavoriteCompetitors = ref.toggleFavoriteCompetitors;
    var _slug;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        className: (0,_utils_cn__WEBPACK_IMPORTED_MODULE_7__.cn)("p-2 flex justify-between items-center transition-colors", favoriteCompetitors.has(team.id) && highlight && "dark:bg-green-900 bg-primary-150 dark:!border-green-600 !border-primary-300", className)
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center gap-3 w-full relative",
                children: [
                    addLink ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        className: "absolute inset-0",
                        href: "/livescore/team/".concat((_slug = team.slug) !== null && _slug !== void 0 ? _slug : team.id)
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,_utils_cn__WEBPACK_IMPORTED_MODULE_7__.cn)("flex items-center justify-center", size === "small" ? "w-8 h-8" : "w-4 h-4"),
                        children: team.logo_url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: team.logo_url,
                            alt: team.name,
                            className: (0,_utils_cn__WEBPACK_IMPORTED_MODULE_7__.cn)("object-contain", size === "small" ? "w-8 h-8" : "w-4 h-4")
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (0,_utils_cn__WEBPACK_IMPORTED_MODULE_7__.cn)("bg-green-400 rounded-full flex items-center justify-center overflow-hidden", size === "small" ? "w-8 h-8" : "w-4 h-4"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (0,_utils_cn__WEBPACK_IMPORTED_MODULE_7__.cn)("font-bold !text-gray-800", size === "small" ? "text-xxs" : "text-[6px]"),
                                children: team.abbreviation
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-xxs -mb-0.5 text-gray-400",
                                children: toPolishGender(team.gender)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "text-[12px] dark:text-white text-black font-medium leading-tight",
                                children: [
                                    team.name,
                                    " ",
                                    team.age_group
                                ]
                            })
                        ]
                    })
                ]
            }),
            icon === "star" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LivescoreFavoriteToggler_LivescoreFavoriteToggler__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                id: team.id,
                isFavorite: favoriteCompetitors.has(team.id),
                onClick: function() {
                    return toggleFavoriteCompetitors(team.id);
                }
            }) : icon === "circle" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LivescoreFavoriteCircleToggler_LivescoreFavoriteCircleToggler__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                id: team.id,
                isFavorite: favoriteCompetitors.has(team.id),
                onClick: function() {
                    return toggleFavoriteCompetitors(team.id);
                }
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                onClick: function() {
                    return toggleFavoriteCompetitors(team.id);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_24_solid__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    className: "w-[26px] h-[26px] p-1 text-gray-400"
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (CompetitorElement);


/***/ }),

/***/ 61638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_cn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72802);


var LivescoreEntityLink = function(param) {
    var children = param.children, href = param.href, isAhref = param.isAhref, className = param.className;
    var handleClick = function(url) {
        window.location.href = url;
    };
    return isAhref ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: href,
        className: className,
        children: children
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_cn__WEBPACK_IMPORTED_MODULE_1__.cn)("cursor-pointer", className),
        onClick: function() {
            return handleClick(href);
        },
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LivescoreEntityLink);


/***/ }),

/***/ 49359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _heroicons_react_24_outline__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82911);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);






var LivescoreFavoriteCircleToggler = function(_param) {
    var isFavorite = _param.isFavorite, id = _param.id, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "isFavorite",
        "id"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(isFavorite), currentState = ref1[0], setCurrentState = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isFavorite !== currentState) {
            setIsVisible(false);
            var timer = setTimeout(function() {
                setCurrentState(isFavorite);
                setIsVisible(true);
            }, 100);
            return function() {
                return clearTimeout(timer);
            };
        } else {
            setIsVisible(true);
        }
    }, [
        isFavorite,
        currentState
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        className: "!w-5 !h-5 relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transition-opacity duration-200 ".concat(isVisible ? "opacity-100" : "opacity-0"),
                children: currentState ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "w-5 h-5 rounded-full bg-primary-600 flex items-center justify-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_24_outline__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        stroke: "#0F0F0F",
                        width: 11,
                        strokeWidth: 3.5
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-5 h-5 rounded-full border border-border-400"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "sr-only",
                children: "Add match to favorites"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (LivescoreFavoriteCircleToggler);


/***/ }),

/***/ 57591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _heroicons_react_24_outline__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53901);
/* harmony import */ var _heroicons_react_24_solid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61646);
/* harmony import */ var next_themes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1571);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);








var LivescoreFavoriteToggler = function(_param) {
    var isFavorite = _param.isFavorite, id = _param.id, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "isFavorite",
        "id"
    ]);
    var ref = (0,next_themes__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .F)(), theme = ref.theme, systemTheme = ref.systemTheme;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isVisible = ref1[0], setIsVisible = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(isFavorite), currentState = ref2[0], setCurrentState = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (isFavorite !== currentState) {
            setIsVisible(false);
            var timer = setTimeout(function() {
                setCurrentState(isFavorite);
                setIsVisible(true);
            }, 100);
            return function() {
                return clearTimeout(timer);
            };
        } else {
            setIsVisible(true);
        }
    }, [
        isFavorite,
        currentState
    ]);
    var isDark = theme === "system" ? systemTheme === "dark" : theme === "dark";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        className: "!w-5 !h-5 relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transition-opacity duration-200 ".concat(isVisible ? "opacity-100" : "opacity-0"),
                children: currentState ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_24_solid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    width: 20,
                    // #31C46C primary-600
                    color: "#31C46C"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_24_outline__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    width: 20,
                    color: "transparent",
                    stroke: isDark ? "white" : "black",
                    strokeWidth: 2
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "sr-only",
                children: "Add match to favorites"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (LivescoreFavoriteToggler);


/***/ }),

/***/ 7955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ FavoriteCompetitorsModalContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_atoms_Input__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95957);
/* harmony import */ var _components_atoms_Wrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89935);
/* harmony import */ var _components_templates_HeadlessModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58180);
/* harmony import */ var _utils_cn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(72802);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _LivescoreSkeleton_LivescoreSkeleton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87643);
/* harmony import */ var _components_atoms_CompetitorElement_CompetitorElement__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15645);
/* harmony import */ var _heroicons_react_24_outline__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49633);












var FavoriteCompetitorsModalContent = function(param) {
    var allTeams = param.allTeams, loading = param.loading, header = param.header;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(allTeams), filteredTeams = ref[0], setFilteredTeams = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(""), search = ref1[0], setSearch = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (search === "") {
            setFilteredTeams(allTeams);
            return;
        }
        var filtered = allTeams.filter(function(team) {
            return team.name.toLowerCase().includes(search.toLowerCase());
        });
        setFilteredTeams(filtered);
    }, [
        search,
        allTeams
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            header ? header : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "absolute top-4 left-4 font-bold text-xl",
                children: "Dodaj nowe ulubione zesp\xf3ły"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Input__WEBPACK_IMPORTED_MODULE_1__/* .Input */ .I, {
                type: "text",
                placeholder: "Szukaj...",
                iconLeft: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_24_outline__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    stroke: "#A1A1AA",
                    width: 24,
                    className: "ml-3"
                }),
                id: "competitor-name-search",
                value: search,
                onChange: function(e) {
                    return setSearch(e.currentTarget.value);
                },
                className: "border-0 mb-4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Wrapper__WEBPACK_IMPORTED_MODULE_2__/* .Wrapper */ .i, {
                className: "mt-2",
                fullWidth: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    className: "list-none px-0 w-full space-y-2 max-h-[388px] overflow-y-scroll customScroll",
                    children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LivescoreSkeleton_LivescoreSkeleton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        items: 6,
                        className: "!w-full relative z-50 h-[58px]"
                    }) : filteredTeams.length === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-center text-gray-400",
                        children: "Brak wynik\xf3w"
                    }) : filteredTeams.slice(0, 32).map(function(team) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "pr-1",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_CompetitorElement_CompetitorElement__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                highlight: true,
                                icon: "circle",
                                team: team,
                                className: "rounded-lg border dark:border-border-400 border-border-250"
                            })
                        }, team.id);
                    })
                })
            })
        ]
    });
};
var FavoriteCompetitorsModal = function(_param) {
    var className = _param.className, isOpen = _param.isOpen, allTeams = _param.allTeams, loading = _param.loading, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "className",
        "isOpen",
        "allTeams",
        "loading"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_templates_HeadlessModal__WEBPACK_IMPORTED_MODULE_3__/* .HeadlessModal */ .l, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
        className: (0,_utils_cn__WEBPACK_IMPORTED_MODULE_11__.cn)("max-w-665 text-white", className),
        isOpen: isOpen,
        containerClassName: "h-screen !overflow-y-hidden",
        isLogo: false
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FavoriteCompetitorsModalContent, {
            allTeams: allTeams,
            loading: loading
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (FavoriteCompetitorsModal);


/***/ }),

/***/ 33882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LivescoreLayout_LivescoreLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/atoms/Wrapper/index.ts + 1 modules
var Wrapper = __webpack_require__(89935);
// EXTERNAL MODULE: ./src/api/ads/index.ts + 2 modules
var api_ads = __webpack_require__(80878);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/organisms/AdCompanion/LivescoreAds/LinvescoreAds.tsx



var LinvescoreAds = function(param) {
    var prefetchedAds = param.prefetchedAds;
    var ref = (0,react.useState)(prefetchedAds !== null && prefetchedAds !== void 0 ? prefetchedAds : null), ads = ref[0], setAds = ref[1];
    (0,react.useEffect)(function() {
        if (ads) return;
        void (0,api_ads/* getAds */.b)([
            "Livescore"
        ]).then(function(data) {
            return setAds(data);
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: "list-none px-0",
        children: ads === null || ads === void 0 ? void 0 : ads.data.sort(function(a, b) {
            return a.attributes.order - b.attributes.order;
        }).map(function(param) {
            var id = param.id, attributes = param.attributes;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "flex justify-center sm:justify-start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: attributes.destinationUrl,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                media: "(min-width: 980px)",
                                srcSet: attributes.desktopImage.data.attributes.url
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: attributes.mobileImage.data.attributes.alternativeText,
                                src: attributes.mobileImage.data.attributes.url
                            })
                        ]
                    })
                })
            }, id);
        })
    });
};
/* harmony default export */ var LivescoreAds_LinvescoreAds = (LinvescoreAds);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/utils/cn.ts + 1 modules
var cn = __webpack_require__(72802);
;// CONCATENATED MODULE: ./src/components/atoms/DividerCard/DividerCard.tsx





var DividerCardTitle = function(_param) /*#__PURE__*/ {
    var children = _param.children, className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className"
    ]);
    return (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,cn.cn)("dark:bg-gray-550 bg-white_theme-100 py-[18px] pl-6 border-b dark:border-border-400 border-gray-250 w-full font-semibold text-base rounded-t-xl dark:text-white text-black", className)
    }, props), {
        children: children
    }));
};
var DividerCardBody = function(_param) /*#__PURE__*/ {
    var children = _param.children, className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className"
    ]);
    return (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,cn.cn)("py-[18px] px-4 w-full", className)
    }, props), {
        children: children
    }));
};
var DividerCard = function(_param) /*#__PURE__*/ {
    var children = _param.children, className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className"
    ]);
    return (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,cn.cn)("border dark:border-border-400 border-gray-250 rounded-xl", className)
    }, props), {
        children: children
    }));
};

;// CONCATENATED MODULE: ./src/components/atoms/DividerCard/index.ts


// EXTERNAL MODULE: ./src/context/LivescoreLayoutContext.tsx
var LivescoreLayoutContext = __webpack_require__(95599);
// EXTERNAL MODULE: ./src/utils/countryCode.ts
var utils_countryCode = __webpack_require__(64027);
;// CONCATENATED MODULE: ./src/components/molecules/TopCompetitionsCard/TopCompetitionsCard.tsx




var CompetitionRecord = function(param) {
    var id = param.id, name = param.name, countryCode = param.countryCode, slug = param.slug;
    var ref;
    var ref1;
    var isoCode = (ref1 = (ref = (0,utils_countryCode/* convertAlpha */.Ob)(countryCode !== null && countryCode !== void 0 ? countryCode : "")) === null || ref === void 0 ? void 0 : ref.toLocaleLowerCase()) !== null && ref1 !== void 0 ? ref1 : "un";
    var countryName = isoCode !== "un" ? (0,utils_countryCode/* getCountryName */.pD)(isoCode) : "Międzynarodowa";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        href: "/livescore/league/".concat(slug !== null && slug !== void 0 ? slug : id),
        className: "flex items-center gap-3 dark:bg-gray-650 bg-white_theme-50 rounded-lg px-4 py-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative h-6 w-6 rounded-full overflow-hidden [mask-image:radial-gradient(white,black)] [-webkit-mask-image:-webkit-radial-gradient(white,black)]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "flex items-center justify-center absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 h-[30px] aspect-[4/3] scale-[0.93]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://flagcdn.com/".concat(isoCode, ".svg"),
                        alt: "".concat(countryName, " flaga"),
                        width: 40,
                        height: 30,
                        className: "h-[30px] w-[40px]"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-medium text-xxs text-gray-400 -mb-0.5",
                        children: countryName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-black dark:text-white font-bold text-[12px] mb-0 h-[16px] overflow-ellipsis line-clamp-1",
                        children: name
                    })
                ]
            })
        ]
    });
};
var TopCompetitionsCard = function() {
    var competitions = (0,LivescoreLayoutContext/* useLivescoreLayout */.z)().competitions;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DividerCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DividerCardTitle, {
                children: "Topowe ligi"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DividerCardBody, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "list-none px-0 space-y-2",
                    children: competitions === null || competitions === void 0 ? void 0 : competitions.enabled.sort(function(a, b) {
                        var ref, ref1, ref2, ref3;
                        var ref4, ref5;
                        var aCode = (ref5 = (ref1 = (0,utils_countryCode/* convertAlpha */.Ob)((ref4 = (ref = a.category) === null || ref === void 0 ? void 0 : ref.country_code) !== null && ref4 !== void 0 ? ref4 : "")) === null || ref1 === void 0 ? void 0 : ref1.toLocaleLowerCase()) !== null && ref5 !== void 0 ? ref5 : "un";
                        var aName = aCode ? (0,utils_countryCode/* getCountryName */.pD)(aCode) : null;
                        var ref6, ref7;
                        var bCode = (ref7 = (ref3 = (0,utils_countryCode/* convertAlpha */.Ob)((ref6 = (ref2 = b.category) === null || ref2 === void 0 ? void 0 : ref2.country_code) !== null && ref6 !== void 0 ? ref6 : "")) === null || ref3 === void 0 ? void 0 : ref3.toLocaleLowerCase()) !== null && ref7 !== void 0 ? ref7 : "un";
                        var bName = bCode ? (0,utils_countryCode/* getCountryName */.pD)(bCode) : null;
                        if (aName === null && bName === null) return 0;
                        if (aName === null) return 1;
                        if (bName === null) return -1;
                        var ref8;
                        return (ref8 = aName === null || aName === void 0 ? void 0 : aName.localeCompare(bName)) !== null && ref8 !== void 0 ? ref8 : 0;
                    }).map(function(param) {
                        var id = param.id, name = param.name, category = param.category, slug = param.slug;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompetitionRecord, {
                                id: id,
                                name: name,
                                countryCode: category === null || category === void 0 ? void 0 : category.country_code,
                                slug: slug
                            })
                        }, id);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var TopCompetitionsCard_TopCompetitionsCard = (TopCompetitionsCard);

// EXTERNAL MODULE: ./src/components/atoms/Button/index.ts + 1 modules
var Button = __webpack_require__(98599);
// EXTERNAL MODULE: ./src/components/molecules/FavoriteCompetitorsModal/FavoriteCompetitorsModal.tsx
var FavoriteCompetitorsModal = __webpack_require__(7955);
// EXTERNAL MODULE: ./src/hooks/useAuthCookies.tsx
var useAuthCookies = __webpack_require__(2195);
// EXTERNAL MODULE: ./src/components/molecules/LivescoreSkeleton/LivescoreSkeleton.tsx
var LivescoreSkeleton = __webpack_require__(87643);
// EXTERNAL MODULE: ./src/components/atoms/CompetitorElement/CompetitorElement.tsx
var CompetitorElement = __webpack_require__(15645);
;// CONCATENATED MODULE: ./src/components/atoms/CompetitorElement/index.ts


;// CONCATENATED MODULE: ./src/components/molecules/FavoriteCompetitorsCard/FavoriteCompetitorsCard.tsx









var FavoriteCompetitorsCard = function() {
    var token = (0,useAuthCookies/* useAuthCookies */.y)().token;
    if (!token) return null;
    var ref = (0,LivescoreLayoutContext/* useLivescoreLayout */.z)(), favoriteCompetitors = ref.favoriteCompetitors, teams = ref.teams, loading = ref.teamsLoading, favoriteCompetitorsModalOpen = ref.favoriteCompetitorsModalOpen, setFavoriteCompetitorsModalOpen = ref.setFavoriteCompetitorsModalOpen;
    var favoriteTeams = (0,react.useMemo)(function() {
        return teams.filter(function(team) {
            return favoriteCompetitors.has(team.id);
        });
    }, [
        teams,
        favoriteCompetitors
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DividerCard, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DividerCardTitle, {
                        children: "Moje drużyny"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DividerCardBody, {
                        children: [
                            favoriteTeams.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "list-none px-0 mb-4",
                                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LivescoreSkeleton/* default */.Z, {
                                    items: 2,
                                    className: "!w-full relative z-50 h-[58px]"
                                }) : favoriteTeams.map(function(team) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "animate-fade-in",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompetitorElement/* CompetitorElement */.i, {
                                            team: team,
                                            icon: "x",
                                            size: "small",
                                            addLink: true
                                        })
                                    }, team.id);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                variant: "outlined",
                                className: "w-full !text-xxs font-bold !border-primary-600 rounded-lg hover:bg-primary-600 hover:text-black-400 text-black dark:text-white transition-colors",
                                onClick: function() {
                                    return setFavoriteCompetitorsModalOpen(true);
                                },
                                children: "Dodaj swoją drużynę"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteCompetitorsModal/* default */.Z, {
                isOpen: favoriteCompetitorsModalOpen,
                variant: "default",
                closeModal: function() {
                    return setFavoriteCompetitorsModalOpen(false);
                },
                allTeams: teams,
                loading: loading
            })
        ]
    });
};
/* harmony default export */ var FavoriteCompetitorsCard_FavoriteCompetitorsCard = (FavoriteCompetitorsCard);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/components/atoms/Input/index.ts + 1 modules
var Input = __webpack_require__(95957);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/disclosure/disclosure.js + 1 modules
var disclosure = __webpack_require__(28368);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/ChevronDownIcon.js
var ChevronDownIcon = __webpack_require__(35871);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/atoms/LivescoreEntityLink/LivescoreEntityLink.tsx
var LivescoreEntityLink = __webpack_require__(61638);
;// CONCATENATED MODULE: ./src/components/molecules/AllCompetitionsCard/AllCompetitionsCard.tsx














var CompetitionCountryCollapse = function(param) {
    var countryCode = param.countryCode, competitions = param.competitions;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1;
    var countryName = (ref1 = countryCode && (0,utils_countryCode/* getCountryName */.pD)(countryCode)) !== null && ref1 !== void 0 ? ref1 : "Międzynarodowe";
    var ref2;
    var countryCodeAlpha2 = (ref2 = countryCode && (0,utils_countryCode/* convertAlpha */.Ob)(countryCode)) !== null && ref2 !== void 0 ? ref2 : "un";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,cn.cn)("text-black dark:text-white rounded-lg overflow-hidden border transition-colors", open ? "dark:border-gray-550 border-white_theme-100" : "dark:border-gray-550/0 border-white_theme-100/0"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Button */.p.Button, {
                    onClick: function() {
                        return setOpen(!open);
                    },
                    className: "dark:bg-gray-650 bg-white_theme-50 group w-full px-4 py-2 transition-all duration-300 relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "h-6 w-6 relative rounded-full overflow-hidden",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "https://flagcdn.com/".concat(countryCodeAlpha2.toLocaleLowerCase(), ".svg"),
                                            alt: "".concat(countryName, " flaga"),
                                            layout: "fill",
                                            objectFit: "cover"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[12px] font-bold overflow-ellipsis line-clamp-1 text-left",
                                        children: countryName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon/* default */.Z, {
                                width: 13,
                                strokeWidth: 3,
                                className: (0,cn.cn)("text-primary-600 transition-transform duration-300 ease-in-out", open && "rotate-180")
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "transition-all duration-[350ms] ease-in-out overflow-hidden ".concat(open ? "max-h-[500000px] opacity-100" : "max-h-0 opacity-0"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "list-none px-4 space-y-3 mt-4",
                        children: competitions.map(function(param) {
                            var id = param.id, name = param.name, slug = param.slug;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "border-b dark:border-gray-650 border-white_theme-100 pb-3 last:border-b-0 animate-fade-in",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LivescoreEntityLink/* default */.Z, {
                                    href: "/livescore/league/".concat(slug !== null && slug !== void 0 ? slug : id),
                                    className: "text-[10px] dark:text-gray-400 text-gray-600",
                                    children: name
                                })
                            }, "competition-".concat(id));
                        })
                    })
                })
            ]
        })
    });
};
var AllCompetitionsCard = function() {
    var competitions = (0,LivescoreLayoutContext/* useLivescoreLayout */.z)().competitions;
    var ref = (0,react.useState)(""), search = ref[0], setSearch = ref[1];
    var ref1 = (0,react.useState)(competitions.all), filtered = ref1[0], setFiltered = ref1[1];
    var ref2 = (0,react.useState)([]), configuredCountries = ref2[0], setConfiguredCountries = ref2[1];
    (0,react.useEffect)(function() {
        function fetchCountriesConfig() {
            return _fetchCountriesConfig.apply(this, arguments);
        }
        function _fetchCountriesConfig() {
            _fetchCountriesConfig = (0,_async_to_generator/* default */.Z)(function() {
                var ref, response, data, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                fetch("/api/livescore/countries-config")
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            data = _state.sent();
                            if (data.success && Array.isArray((ref = data.data) === null || ref === void 0 ? void 0 : ref.countries)) {
                                setConfiguredCountries(data.data.countries);
                            }
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return _fetchCountriesConfig.apply(this, arguments);
        }
        fetchCountriesConfig();
    }, []);
    (0,react.useEffect)(function() {
        if (search) {
            var newFiltered = Object.fromEntries(Object.entries(competitions.all).map(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], comps = _param[1];
                var filteredCompetitions = comps.filter(function(c) {
                    return c.name.toLowerCase().includes(search.toLowerCase());
                });
                return [
                    key,
                    filteredCompetitions
                ];
            }).filter(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _ = _param[0], comps = _param[1];
                return comps.length > 0;
            }));
            setFiltered(newFiltered);
        } else if (configuredCountries.length > 0) {
            var newFiltered1 = Object.fromEntries(Object.entries(competitions.all).filter(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 1), key = _param[0];
                return configuredCountries.includes(key);
            }));
            setFiltered(newFiltered1);
        } else {
            setFiltered(competitions.all);
        }
    }, [
        search,
        competitions.all,
        configuredCountries
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DividerCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DividerCardTitle, {
                children: "Wszystkie ligi"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DividerCardBody, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                        placeholder: "Wyszukaj ligę",
                        id: "search",
                        className: "mb-3 !border-0 -mt-1",
                        value: search,
                        onChange: function(e) {
                            return setSearch(e.currentTarget.value);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "list-none px-0 space-y-3",
                        children: Object.keys(filtered).slice(0, 5).sort(function(a, b) {
                            if (search === "") return 0;
                            return a.localeCompare(b);
                        }).map(function(key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "animate-fade-in",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompetitionCountryCollapse, {
                                    countryCode: key,
                                    competitions: filtered[key]
                                })
                            }, key);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var AllCompetitionsCard_AllCompetitionsCard = (AllCompetitionsCard);

// EXTERNAL MODULE: ./src/api/livescore/client.ts + 20 modules
var client = __webpack_require__(79800);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/MagnifyingGlassIcon.js
var MagnifyingGlassIcon = __webpack_require__(89396);
// EXTERNAL MODULE: ./node_modules/usehooks-ts/dist/index.mjs
var dist = __webpack_require__(79661);
;// CONCATENATED MODULE: ./src/components/molecules/LivescoreSearch/LivescoreSearch.tsx










var LivescoreSearch = function() {
    var ref = (0,react.useState)(false), isFocus = ref[0], setIsFocus = ref[1];
    var ref1 = (0,react.useState)(""), value = ref1[0], setValue = ref1[1];
    var debouncedValue = (0,dist/* useDebounce */.Nr)(value, 500);
    var ref2 = (0,react.useState)(false), error = ref2[0], setError = ref2[1];
    var ref3 = (0,react.useState)([]), data = ref3[0], setData = ref3[1];
    var ref4 = (0,react.useState)(false), loading = ref4[0], setLoading = ref4[1];
    (0,react.useEffect)(function() {
        var search = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var response;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!debouncedValue) {
                                setData([]);
                                return [
                                    2
                                ];
                            }
                            setLoading(true);
                            return [
                                4,
                                client/* livescoreClient.apiSearchGet */.Z.apiSearchGet({
                                    q: debouncedValue
                                })
                            ];
                        case 1:
                            response = _state.sent();
                            if (!response.data.success) {
                                setError(true);
                                return [
                                    2
                                ];
                            }
                            setError(false);
                            if (response.data.data.entities) {
                                setData(response.data.data.entities);
                            }
                            setLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function search() {
                return _ref.apply(this, arguments);
            };
        }();
        search();
    }, [
        debouncedValue
    ]);
    var _img_url;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "h-10 w-full relative",
        children: [
            (isFocus || value !== "") && data.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fixed z-40 bg-black-transparent w-full h-full top-0 left-0",
                "aria-hidden": true
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,cn.cn)("absolute top-0 left-0 w-full border rounded-lg transition-colors dark:bg-gray-650 bg-white_theme-50 z-50", isFocus || value !== "" ? "border-primary-600" : "border-transparent"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                        id: "livescore-sidebar-search",
                        iconLeft: /*#__PURE__*/ (0,jsx_runtime.jsx)(MagnifyingGlassIcon/* default */.Z, {
                            className: "text-gray-400 ml-2",
                            width: 16,
                            height: 16
                        }),
                        className: "!h-10 mt-0 !border-0 text-gray-400 !px-2",
                        inputClassName: "!border-0",
                        placeholder: "Szukaj...",
                        onFocus: function() {
                            return setIsFocus(true);
                        },
                        onBlur: function() {
                            return setIsFocus(false);
                        },
                        value: value,
                        onChange: function(e) {
                            return setValue(e.currentTarget.value);
                        }
                    }),
                    error ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-xs text-gray-400 mt-1",
                        children: "Wystąpił błąd"
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: (0,cn.cn)("list-none px-4", isFocus || value !== "" ? "block" : "hidden"),
                        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: Array.from({
                                length: 4
                            }).map(function(_, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "first:!border-t-0 border-t dark:border-border-400 border-white_theme-100 animate-pulse",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "py-2 flex items-center gap-4 w-full",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-[23px] h-[23px] rounded-full bg-gray-600"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "min-h-[40px] flex flex-col justify-center gap-1",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "h-3 bg-gray-600 rounded w-16"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "h-3 bg-gray-600 rounded w-24"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, index);
                            })
                        }) : data.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "first:!border-t-0 border-t dark:border-border-400 border-white_theme-100",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    href: "/livescore/".concat(item.type, "/").concat(item.slug ? item.slug : item.id),
                                    className: "py-2 flex items-center gap-4 w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,cn.cn)("w-[23px] h-[23px] flex items-center justify-center rounded-full overflow-hidden relative", !item.img_url && "bg-gray-400", item.type === "league" && "bg-gray-50 p-1"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "relative w-full h-full",
                                                children: item.img_url || item.type === "player" ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: (_img_url = item.img_url) !== null && _img_url !== void 0 ? _img_url : "/images/player.png",
                                                    alt: item.name,
                                                    layout: "fill",
                                                    objectFit: "contain"
                                                }) : null
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "min-h-[40px] flex flex-col justify-center",
                                            children: [
                                                item.gender ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-xxs text-gray-400",
                                                    children: item.gender === "male" ? "Mężczyźni" : "Kobiety"
                                                }) : null,
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: (0,cn.cn)("text-[13px] font-semibold dark:text-white text-black", item.gender && "-mt-1.5"),
                                                    children: [
                                                        item.name,
                                                        " ",
                                                        item.age_group ? item.age_group : ""
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, item.id);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var LivescoreSearch_LivescoreSearch = (LivescoreSearch);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/atoms/LivescoreSidebarTabs/LivescoreSidebarTabs.tsx




var links = [
    {
        label: "Livescore",
        url: "/livescore"
    },
    {
        label: "Centrum Ulubionych",
        url: "/livescore/favorite-center"
    }, 
];
var LivescoreSidebarTabs = function() {
    var token = (0,useAuthCookies/* useAuthCookies */.y)().token;
    var router = (0,next_router.useRouter)();
    if (!token) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full flex items-center gap-4",
        children: links.map(function(param) {
            var label = param.label, url = param.url;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: url,
                className: (0,cn.cn)("font-bold rounded-lg border w-full text-center uppercase text-[12px] py-2", router.pathname === url ? "dark:bg-green-400 bg-primary-150 dark:text-green-900 text-primary-600 dark:border-green-600 border-primary-400" : "dark:border-green-600 border-gray-250 dark:bg-green-900 bg-white_theme-50 dark:text-green-400 text-gray-600"),
                children: label
            }, label);
        })
    });
};
/* harmony default export */ var LivescoreSidebarTabs_LivescoreSidebarTabs = (LivescoreSidebarTabs);

// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/ChevronRightIcon.js
var ChevronRightIcon = __webpack_require__(31038);
// EXTERNAL MODULE: ./src/context/AppContext.tsx
var AppContext = __webpack_require__(64574);
;// CONCATENATED MODULE: ./src/components/molecules/LivescoreLayout/LivescoreLayout.tsx












var LivescoreLayout = function(param) {
    var children = param.children, ads = param.ads;
    var ref = (0,react.useState)(false), opened = ref[0], setOpened = ref[1];
    var ribbonClosed = (0,AppContext/* useApp */.q)().ribbonClosed;
    (0,react.useEffect)(function() {
        if (opened) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
        return function() {
            document.body.style.overflow = "unset";
        };
    }, [
        opened
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper/* Wrapper */.i, {
        className: "grid md:grid-cols-[1fr_2fr] grid-cols-1 gap-4 px-4 md:mt-0 mt-20",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,cn.cn)("h-screen md:h-auto overflow-y-scroll md:relative fixed md:w-auto w-full top-0 flex z-40 pr-1 md:pr-0 transition-all crollbar-none [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]", opened ? "left-0" : "-left-[calc(100%-32px)] md:left-0"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,cn.cn)("sm:hidden block fixed inset-0 h-full w-[calc(100vw-32px)] dark:bg-black-500 bg-white -z-10 md:border-r-0 border-r dark:border-border-400 border-gray-250", opened ? "left-0" : "-left-[calc(100%-32px)] md:left-0"),
                        "aria-hidden": true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,cn.cn)("relative space-y-6 md:bg-transparent px-4 w-[calc(100vw-32px)] md:w-fit", ribbonClosed ? "md:pt-0 pt-20" : "md:pt-0 pt-36"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LivescoreSearch_LivescoreSearch, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LivescoreSidebarTabs_LivescoreSidebarTabs, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopCompetitionsCard_TopCompetitionsCard, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteCompetitorsCard_FavoriteCompetitorsCard, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LivescoreAds_LinvescoreAds, {
                                prefetchedAds: ads
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AllCompetitionsCard_AllCompetitionsCard, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-4 w-1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: function() {
                                return setOpened(function(prev) {
                                    return !prev;
                                });
                            },
                            className: "md:hidden fixed top-[20vh] rounded-r-md dark:bg-black-500 bg-white_theme-100 translate-x-[-1px] h-fit py-2 border-r border-t border-b dark:border-border-400 border-gray-250",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRightIcon/* default */.Z, {
                                width: 24,
                                className: (0,cn.cn)("transition-transform text-black dark:text-white", opened ? "rotate-180" : "")
                            })
                        })
                    })
                ]
            }),
            children
        ]
    });
};
/* harmony default export */ var LivescoreLayout_LivescoreLayout = (LivescoreLayout);


/***/ }),

/***/ 87643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_atoms_Skeleton_Skeleton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28254);
/* harmony import */ var _utils_cn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72802);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);






var LivescoreSkeleton = function(_param) {
    var items = _param.items, className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "items",
        "className"
    ]);
    var arr = Array.from({
        length: items
    }, function(_, i) {
        return i;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: arr.map(function(item) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: "animate-fade-in",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Skeleton_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                    className: (0,_utils_cn__WEBPACK_IMPORTED_MODULE_5__.cn)("rounded-lg w-full h-[72px]", className)
                }, props))
            }, "livescore-skeleton-".concat(item));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LivescoreSkeleton);


/***/ }),

/***/ 95599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LivescoreLayoutProvider; },
/* harmony export */   "z": function() { return /* binding */ useLivescoreLayout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useSet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49344);
/* harmony import */ var _api_user__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42500);
/* harmony import */ var _hooks_useToast__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95720);
/* harmony import */ var _hooks_useAuthCookies__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2195);
/* harmony import */ var _api_livescore_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79800);










var LivescoreLayoutContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(undefined);
var LivescoreLayoutProvider = function(param) {
    var children = param.children, competitions = param.competitions, favoriteMatchesInit = param.favoriteMatchesInit, favoriteCompetitorsInit = param.favoriteCompetitorsInit;
    var favoriteMatches = (0,_hooks_useSet__WEBPACK_IMPORTED_MODULE_2__/* .useSet */ .$)(favoriteMatchesInit);
    var favoriteCompetitors = (0,_hooks_useSet__WEBPACK_IMPORTED_MODULE_2__/* .useSet */ .$)(favoriteCompetitorsInit);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), teams = ref[0], setTeams = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), teamsLoading = ref1[0], setTeamsLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), favoriteCompetitorsModalOpen = ref2[0], setFavoriteCompetitorsModalOpen = ref2[1];
    var ref3 = (0,_hooks_useToast__WEBPACK_IMPORTED_MODULE_4__/* .useToast */ .p)(), showErrorToggleFavoriteCompetitorToast = ref3.showErrorToggleFavoriteCompetitorToast, showErrorToggleFavoriteMatchToast = ref3.showErrorToggleFavoriteMatchToast, showErrorToggleFavoriteMatchNotLoggedInToast = ref3.showErrorToggleFavoriteMatchNotLoggedInToast, showLivescoreFetchTeamsErrorToast = ref3.showLivescoreFetchTeamsErrorToast;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        function fetchTeamsData() {
            return _fetchTeamsData.apply(this, arguments);
        }
        function _fetchTeamsData() {
            _fetchTeamsData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                var response;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _api_livescore_client__WEBPACK_IMPORTED_MODULE_5__/* .livescoreClient.apiTeamsGet */ .Z.apiTeamsGet()
                            ];
                        case 1:
                            response = _state.sent();
                            if (!response.data.success) {
                                showLivescoreFetchTeamsErrorToast();
                            }
                            setTeams(response.data.data.teams);
                            setTeamsLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return _fetchTeamsData.apply(this, arguments);
        }
        fetchTeamsData();
    }, []);
    var token = (0,_hooks_useAuthCookies__WEBPACK_IMPORTED_MODULE_8__/* .useAuthCookies */ .y)().token;
    var toggleMatchToFavorites = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(matchId) {
            var newFavoriteMatches, response, status;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!token) {
                            showErrorToggleFavoriteMatchNotLoggedInToast();
                            return [
                                2
                            ];
                        }
                        if (!favoriteMatches.has(matchId)) {
                            newFavoriteMatches = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(favoriteMatches.values).concat([
                                matchId
                            ]);
                        } else {
                            newFavoriteMatches = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(favoriteMatches.values).filter(function(id) {
                                return id !== matchId;
                            });
                        }
                        return [
                            4,
                            (0,_api_user__WEBPACK_IMPORTED_MODULE_3__/* .setOwnFavoriteMatches */ .Yy)(token, newFavoriteMatches)
                        ];
                    case 1:
                        response = _state.sent();
                        status = response.status.toString();
                        if (!status.startsWith("2")) {
                            showErrorToggleFavoriteMatchToast(favoriteMatches.has(matchId));
                            return [
                                2
                            ];
                        }
                        favoriteMatches.clear();
                        newFavoriteMatches.forEach(function(val) {
                            favoriteMatches.add(val);
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function toggleMatchToFavorites(matchId) {
            return _ref.apply(this, arguments);
        };
    }();
    var toggleFavoriteCompetitors = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(competitorId) {
            var oldFavoriteCompetitors, newFavoriteCompetitors, response;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        oldFavoriteCompetitors = Array.from(favoriteCompetitors.values);
                        if (favoriteCompetitors.has(competitorId)) {
                            newFavoriteCompetitors = oldFavoriteCompetitors.filter(function(comp) {
                                return comp !== competitorId;
                            });
                        } else {
                            newFavoriteCompetitors = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(oldFavoriteCompetitors).concat([
                                competitorId
                            ]);
                        }
                        return [
                            4,
                            (0,_api_user__WEBPACK_IMPORTED_MODULE_3__/* .setOwnFavoriteCompetitors */ .M9)(token, newFavoriteCompetitors)
                        ];
                    case 1:
                        response = _state.sent();
                        if (!response.status.toString().startsWith("2")) {
                            showErrorToggleFavoriteCompetitorToast(favoriteCompetitors.has(competitorId));
                            return [
                                2
                            ];
                        }
                        favoriteCompetitors.clear();
                        newFavoriteCompetitors.forEach(function(val) {
                            favoriteCompetitors.add(val);
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function toggleFavoriteCompetitors(competitorId) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LivescoreLayoutContext.Provider, {
        value: {
            competitions: competitions,
            favoriteMatches: favoriteMatches.values,
            favoriteCompetitors: favoriteCompetitors.values,
            toggleMatchToFavorites: toggleMatchToFavorites,
            toggleFavoriteCompetitors: toggleFavoriteCompetitors,
            teamsLoading: teamsLoading,
            teams: teams,
            favoriteCompetitorsModalOpen: favoriteCompetitorsModalOpen,
            setFavoriteCompetitorsModalOpen: setFavoriteCompetitorsModalOpen
        },
        children: children
    });
};
var useLivescoreLayout = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(LivescoreLayoutContext);
    if (!context) {
        throw new Error("useLivescoreLayout must be used within an LivescoreLayoutProvider");
    }
    return context;
};


/***/ }),

/***/ 49344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useSet; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
"use client";

function setReducer(state, action) {
    var newSet = new Set(state);
    switch(action.type){
        case "add":
            newSet.add(action.value);
            return newSet;
        case "remove":
            newSet.delete(action.value);
            return newSet;
        case "toggle":
            newSet.has(action.value) ? newSet.delete(action.value) : newSet.add(action.value);
            return newSet;
        case "clear":
            return new Set();
        default:
            return state;
    }
}
/**
 * Custom hook for managing a set of values with common set operations.
 * @param initialValues Optional initial values for the set
 * @returns A set and functions to modify it
 */ function useSet(initialValues) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(setReducer, initialValues ? new Set(initialValues) : new Set()), values = ref[0], dispatch = ref[1];
    return {
        values: values,
        add: function(value) {
            return dispatch({
                type: "add",
                value: value
            });
        },
        remove: function(value) {
            return dispatch({
                type: "remove",
                value: value
            });
        },
        toggle: function(value) {
            return dispatch({
                type: "toggle",
                value: value
            });
        },
        clear: function() {
            return dispatch({
                type: "clear"
            });
        },
        has: function(value) {
            return values.has(value);
        }
    };
}


/***/ })

}]);